export default {
  login: {
    title: 'Welcome',
    titleDescription: 'Connect to access your Ubiflow customer space',
    username: 'Username',
    usernameSFC: 'Email adresse',
    usernamePlaceholder: 'Enter your login ID (Client code or email)',
    usernamePlaceholderSFC: 'Enter login email Se Faire connaître',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    logIn: 'Log In',
    passwordLost: 'Forgotten your password ?',
    passwordLostLink: 'Click here to reset it',
    metaTitle: 'Connection to Ubiflow customer space',
    dialogSuspendedTitle: 'Customer area suspended',
    dialogSuspendedText: 'A late payment prevents access to your Ubiflow Customer Area.<br />You can contact our ADV team (<a href="mailto:adv@ubiflow.net">adv@ubiflow.net</a> ) to regularize your situation.<br /><br />See you soon.',
    SFCErrorTitle: 'Connexion error',
    SFCErrorText: 'An error was encountered when connecting to your Ubiflow customer area - Se Faire Connaître. We apologize for the inconvenience caused. We invite you to contact our Customer Relations department either by phone at 02.30.95.20.00 or by email at:'
  },
  lostPassword: {
    title: 'Forgotten password',
    titleDescription: 'Reset your password',
    username: 'Username or email',
    usernamePlaceholder: 'Enter your client code or email',
    confirm: 'OK',
    confirmationTitle: 'Forgotten password',
    confirmationText: 'An email has been sent to you. Follow the instructions to reset your password and access your Customer Space.',
    backToLogin: 'Go back to the login form?',
    backToLoginLink: 'Click here',
    metaTitle: 'Forgotten password',
    confirmationTitleSFC: 'Changing your password',
    confirmationText1SFC: 'An email has just been sent to your address',
    confirmationText2SFC: 'Follow the instructions on it to renew your password and access your Ubiflow customer area - Se Faire Connaître'
  },
  changePassword: {
    title: 'Forgotten password',
    titleDescription: 'Reset your password',
    password1: 'Choose a password',
    password1Placeholder: 'Choose a password',
    password2: 'Confirm your password',
    password2Placeholder: 'Confirm your password',
    confirm: 'OK',
    backToLogin: 'Go back to the login form?',
    backToLoginLink: 'Click here',
    metaTitle: 'Forgotten password'
  },
  activateProduct: {
    pageTitle: 'Product activation',
    title: 'Welcome',
    titleDescription: 'You can now enter your code to activate your qualification form.',
    titleDescriptionResponse: 'You have activated your form. You can now close this page',
    productActivateResponse: 'You have activated your form.',
    labelCode: 'Activation code',
    labelButton: 'Enable',
    codeRequired: 'The code is required'
  },
  forbidden403: {
    title: 'Forbidden access',
    text: "You don't have access to this page.",
    link: 'Go back to home',
    metaTitle: 'Error 403 - Forbidden access'
  },
  notFound404: {
    title: 'Not found page',
    text: "The page you are looking for doesn't exist or has been moved.",
    link: 'Go back to home',
    metaTitle: 'Error 404 - Not found page'
  },
  unauthorized401: {
    title: 'Unauthorized Access',
    text: 'You must be authenticated to access this page.',
    link: 'Log in',
    metaTitle: 'Error 401 - Unauthorized Access'
  },
  serverError500: {
    message: 'An error occurred while loading the data.'
  },
  layouts: {
    notificationAlerts: 'Alerts',
    notifications: 'Notifications',
    noNotification: 'No notification for the moment',
    createAd: 'Create ad',
    create_program: 'Create program',
    contactUs: 'Contact us',
    portailClient: 'My Invoices area',
    logOut: 'Log out',
    goBackOldCustomerSpace: 'Go back to old customer space',
    contactBook: 'My users',
    dashboard: 'Dashboard',
    ads: 'Ads',
    selectionVo: 'Dealer Car',
    programs: 'Programs',
    home: 'Home',
    portals: 'Portals',
    profile: 'Profile',
    diffusion: 'Diffusion',
    contactManager: 'Contact Manager',
    localPresence: 'Local presence',
    socialManagment: 'Social manager',
    localReference: 'Local reference',
    postManagement: 'Post Management',
    planningCalendar: 'Planning calendar',
    sfc: 'Se faire connaitre',
    offeredBy: 'Customer Space offered by',
    ubiflow: 'Ubiflow',
    legalNotice: 'Legal notice',
    conditionsOfSale: 'Terms',
    conditionsOfSaleOfDiffusion: 'Terms Diffusion',
    conditionsOfSaleOfContactManager: 'Terms Contact Manager',
    conditionsOfSaleOfSocialManager: 'Terms Social Manager',
    titleTemplate: "Ubiflow's Customer Space",
    personalInformation: 'My settings',
    help: 'Help',
    changeUser: 'Change user',
    warning: 'Caution',
    dactivateAdBlock: 'It seems that an ad blocker is preventing your data from showing. Please deactivate it.',
    exportSuccess: 'The export of your data is being created, you will receive an email as soon as it is available.',
    exportErrorAccess: 'You do not have access to this feature',
    exports: 'My Exports',
    quotas: 'Manage my quotas',
    sponsorshipImmo: 'Sponsor a real estate professional and receive €50 as a gift card! Click for more information !',
    sponsorshipVo: 'Sponsor an automotive professional and receive €50 as a gift card! Click for more information !',
    socialNetworks: 'Social networks',
    contactsVisitesTitle: 'Visits by ads',
    portalsSocialManagment: 'Social media distribution',
    annoncesCommerciaux: 'Advertisements by commercial',
    socialReviews: 'Customer reviews',
    statistics: 'Statistics'
  },
  popup: {
    oldCustomerArea: 'Closing of the old customer area'
  },
  routes: {
    homeTitle: 'Home',
    myAccountTitle: 'My settings',
    localPresenceTitle: 'Locale SEO',
    ubiflowProducts: 'Ubiflow Products',
    contactUsTitle: 'Contact us',
    tutorialsVideosTitle: 'Help',
    myWebsiteTitle: 'My website',
    conditionsOfSaleTitle: 'Terms',
    conditionsOfSaleOfDiffusionTitle: 'Terms diffusion',
    conditionsOfSaleOfContactManagerTitle: 'Terms contact Manager',
    globalIntegrationReport: 'Global integration report',
    globalDiffusionReport: 'Global diffusion report',
    adsTitle: 'Ads',
    adsListTitle: 'List of ads',
    createAdTitle: 'Create an ad',
    createAdModelTitle: 'Create a model',
    adDetailsTitle: 'Ad details',
    editAdTitle: 'Edit ad',
    adsSelectionTitle: 'Ads selection',
    diffusionSelectionTitle: 'Diffusions selection',
    presenceReportTitle: 'Presence report',
    contactManagerTitle: 'Contact Manager',
    contactsSynthesisDiffusionTitle: 'Synthesis of the contacts generated by my diffusions',
    contactsGeneratedByPortalsTitle: 'Contacts generated by my portals',
    contactsDetailsPerPortalTitle: 'Contacts detail per portal',
    contactsGeneratedByAdsTitle: 'Contacts generated by my ads',
    contactsDetailsPerAdTitle: 'Contacts detail per ad',
    contactsSynthesisTitle: 'Synthesis of the contacts',
    contactsGeneratedTitle: 'Contacts generated',
    demandeRapprochementDetailsPerPortalTitle: 'Contact Requests',
    diffusionsListTitle: 'List of diffusions',
    diffusionSelogerTitle: 'Seloger group',
    diffusionReportTitle: 'Diffusion report',
    diffusionsPerAdTitle: 'Diffusions per ad',
    myAccountsTitle: 'My accounts',
    comptes: 'Accounts',
    diffusion: 'difusión',
    program: 'Programs',
    lot: 'Lots',
    exports: 'My exports',
    quotas: 'Manage quotas',
    contentLibrary: 'My content library',
    PrivateNote: 'Private note of the ad',
    managePosts: 'Manage my posts',
    editBienVendu: 'Manage the property sold',
    newBienVendu: 'Creation of a sold property',
    socialNetworks: 'My social networks',
    ubiflowProductQualiforma: 'Qualification form',
    portalsSocialManagmentTitle: 'Social media distribution',
    statistics: 'Statistics',
    modelsEditoLibrary: 'Editorial post templates library'
  },
  contact: { // contact form
    mainText: 'You have a question about your customer space, ' +
              'need more <strong>information about a product</strong> or you would like to share ' +
              'a feedback with our team and give us some ' +
              '<strong>improvement suggestions</strong>, contact us filling the following form.',
    object: 'Subject of your message *',
    objectOption1: 'Ask a question about a product',
    objectOption2: 'Suggest a new portal',
    objectOption3: 'Ask a question about your new customer space',
    objectOption4: 'Suggest an improvement of the customer space',
    objectOption5: 'Other',
    objectOption6: 'Ask for help',
    writeMessage: 'Write your message *',
    writeMessagePlaceholder: 'To help us answer you better, if your question is related to an ad or a diffusion, ' +
                             'please indicate the ad reference, the portal name, etc.',
    name: 'Your lastname and firstname',
    email: 'Your email *',
    phone: 'Your phone number',
    sendEmailCopy: 'Send a copy to my own email',
    send: 'Send my request',
    ruleObjectRequired: 'The subject is mandatory',
    ruleMessageRequired: 'The message is mandatory',
    ruleEmailRequired: 'The email is mandatory',
    rulePhoneNumber: 'Only numbers',
    messageEmailSent: 'Your email has been sent successfully',
    messageEmailError: 'An error occurred'
  },
  contacts: { // Contact Manager
    noActivated: {
      title: 'Contact manager',
      title1: 'This functionality is not activated in your subscription',
      text1: 'You need to control and accelerate your sales to your future clients ?<br/>' +
             'You want to closely monitor all the contacts received from portals ?',
      title2: 'Counting and statisticsMeta',
      text2: 'All the contacts from your multi-diffusion subscription, even portals ' +
             'you publish ads to without using Ubiflow, are recorded day after day. ' +
             'A summary table is sent to you weekly.',
      title3: 'Archiving your contacts',
      text3: 'Under the section « Contacts generated by my diffusions », ' +
             'you have access to the full list and history of all your prospects. ' +
             'A user-friendly layout, a search field, a sort by date, the possibility ' +
             'of exporting the list of your contacts... Many tools that allow you to durably monitor your contacts ' +
             'and ensure a good exploitation by your team.',
      title4: 'The right contact to the right person',
      text4: 'Contacts are sent directly to the dedicated sale representatives, if the reference of the ad allows to identify him.',
      title5: 'Request simplification',
      text5: 'All the emails received from portals are standardized to an unique format, where the information you are looking for ' +
             "is easily visible. You won't get lost anymore in a huge volume of different emails in order to " +
             'find your contact requests.',
      discover: 'Discover the product',
      beContacted: 'Interested by this product? Be contacted by a comercial advisor.',
      emailSubject: 'Client {{advertiser}} : Contact Manager - Contact Request',
      emailContent: 'The client {{advertiser}} ({{companyName}}) sent a contact request from the new ' +
                    'customer space for the product "Contact Manager". You may contact him ' +
          'via {{email}} or at this number {{phoneNumber}}',
      dialogMessage: 'You requested more information about our product Contact Manager. Our team will contact you as soon as possible.',
      listUniqueContacts: 'Unique Contacts'
    },
    generatedByPortals: 'Generated contacts by my portals',
    generatedByAds: 'Generated contacts by my ads',
    accessToCockpit: 'Access to Cockpit',
    accumulatedIndicators: 'Accumulated activity indicators over the current period',
    exportEmailContacts: 'Export email contacts',
    exportPhoneContacts: 'Export call contacts',
    exportResults: 'Export results',
    generatedContactsTotal: 'contact generated (total)',
    generatedContactsTotal_plural: 'contacts generated (total)',
    tooltipTotal: 'On diffused and not diffused ads',
    generatedContactsActiveAds: 'contact generated (active ads)',
    generatedContactsActiveAds_plural: 'contacts generated (active ads)',
    tooltipActiveAds: 'Contacts generated on ads currently being diffused',
    contactsByEmail: 'Email contacts',
    contactsByPhone: 'Call contacts',
    adsSent: 'Ad diffused',
    adsSent_plural: 'Ads diffused',
    activePortals: 'Active portal',
    activePortals_plural: 'Active portals',
    activityDistributionTitle: 'Activity distribution within the current period for ads currently being diffused',
    activityDistributionEmailContacts: 'Email contacts distribution (diffused ads)',
    activityDistributionNoData: 'No data for this period',
    activityDistributionOffers: 'Offers',
    activityDistributionProperties: 'Properties',
    activityDistributionPortals: 'Portals',
    contactDetailsTitle: 'Received contacts detail',
    activityDistributionTitleVO: 'Distribution of contacts generated over the current period on the ads being diffused',
    contactDetailsLastMonths: '12 last months',
    contactDetailsLastDays: '30 last days',
    listGeneratedContactsTotal: 'Total contacts generated',
    listDemandesRapprochementTotal: 'Total contact requests generated',
    listGeneratedProspectsTotal: 'Total prospects generated',
    listGeneratedCallContactsTotal: 'Total call contacts',
    listGeneratedEmailContactsTotal: 'Total email contacts',
    listTooltipTotal: 'On diffused and not diffused ads',
    listGeneratedContactsMail: 'Email contacts generated',
    listTooltipMail: 'Email contacts generated by ads currently being diffused',
    listGeneratedContactsAds: 'Contacts generated by ads currently being diffused',
    listAdsSentContacts: 'Contacts generated (diffused ads)',
    listAdsSent: 'Total ads diffused',
    listActivePortals: 'Total active portals',
    listPortalsEquippedWithCM: 'Portals equipped with Contact Manager',
    listGraphNoData: 'No data for this period',
    listGraphDistributionByMail: 'Email contacts distribution',
    listGraphAdsSent: 'diffused ads',
    listGraphAdsSentDistribution: 'Distribution (diffused ads)',
    listTableNoData: 'No data for this period',
    listTablePropertyTypes: 'Property types',
    listTableOfferTypes: 'Offer types',
    listColumnLogo: 'Logo',
    listColumnPortal: 'Portal name',
    listColumnBusinessModel: 'Economic model',
    listColumnContactsTotal: 'Total contacts',
    listColumnContactsMail: 'Email contacts',
    listColumnContactsTel: 'Call contacts',
    listColumnAds: 'Ads',
    listColumnAdsNoActiveDiffusion: 'No active diffusion',
    listColumnTooltipAdNoSent: 'This ad is not or not anymore diffused',
    listColumnAd: 'Ad',
    listColumnReference: 'Reference',
    listColumnActivePortals: 'Active portals',
    listColumnContacts: 'Contacts',
    listColumnDate: 'Date',
    listColumnDateAndHour: 'Date and time',
    listColumnAdReference: 'Ad reference',
    listColumnCivilityLastnameFirstname: 'Civility, lastname, firstname',
    listColumnEmail: 'Email',
    listColumnScoring: 'Scoring',
    listColumnPhoneNumber: 'Phone',
    listColumnFormLink: 'Form details',
    listColumnCallStatus: 'Call status',
    listColumnCallDuration: 'Call duration',
    listColumnDemandesRapprochement: 'Contact Requests',
    listTabMailtracking: 'Mail tracking',
    listTabMailtrackingPostalCode: 'Postal code',
    listTabMailtrackingCity: 'City',
    listTabMailtrackingAdAddress: 'ad address',
    listTabMailtrackingNoInformation: 'Not specified',
    listTabCalltracking: 'Call tracking',
    listTabCalltrackingCallAnswered: 'Call answered',
    listTabCalltrackingCallMissed: 'Call missed',
    listUniqueAds: 'Unique ads',
    toolTipAdNotDiffused: 'This ad is not anymore diffused',
    generalInformation: 'General information',
    postReference: 'Reference',
    postPrice: 'Price',
    postLocation: 'Location',
    postEmptyField: 'This field is empty',
    buttonContactsByPortal: 'Contacts by portal',
    buttonContactsByAd: 'Contacts by ad',
    buttonContactsAll: 'All Contacts',
    buttonContactsVisites: 'Visits by ad',
    filenameExportContactsPortals: 'contacts_portals',
    filenameExportContactsAds: 'contacts_ads',
    filenameExportContactsPerPortal: 'contacts_by_portal',
    filenameExportContactsPerAd: 'contacts_ad',
    filenameExportContactsCalls: 'contacts_calltracking',
    filenameExportContacts: 'summary_contacts',
    contactGenere: 'contacts generated',
    listTooltipUniqueAds: 'Number of unique ads affected by contacts',
    visites: {
      columnDateVisite: 'Date and time of visit',
      columnAdReference: 'Reference',
      columnJaugeVisite: 'Nb of registrants / Maximum nb of visitors',
      columnNbAttente: 'Nb of candidates waiting',
      columnListeCandidatsExport: 'List of candidates',
      columnAdStatut: 'Announcement status',
      searchByReference: 'Search by reference',
      adActive: 'Active',
      adInactive: 'Inactive'
    }
  },
  quotas: {
    validerQuotas: 'CONFIRM THIS QUOTA DISTRIBUTIONS',
    repartitionQuotas: 'Distribute quotas equally',
    total: 'Total',
    portails: 'Portals',
    succesUpdate: 'Your quotas have been modified',
    quotaPerso: 'Personal quota',
    txtPresentationQuota: 'From this page, you can configure the distribution of your diffusion quotas by user. You can edit it manually or choose an equitable distribution.',
    txtAucunQuota: 'No data can be displayed, either because all your diffusions are in "unlimited" status or because no user has a stock of ads.',
    max: 'Max quota',
    tooltipsTotalQuotas: 'Total ads broadcast / total quotas allocated'
  },
  website: {
    title: 'Website',
    functionalityNoActivated: 'This functionality is not activated in your subscription.',
    contactUs: 'Contact us'
  },
  presenceLocale: {
    title: 'Solution "Se Faire Connaître"',
    text1: 'Make your business shine locally and go further in your relationship with your future customers thanks to our ',
    keywordText1: 'local SEO offer.',
    text2Bold: '1 - Improve your local visibility on the Internet.',
    text2: 'Our solution makes it possible to distribute automatically, and without any effort on your part, the information of your point(s) of sale on the 16 media in our catalog (Google, Maps, Facebook, Waze, Foursquare, . ..)',
    text3Bold: '2 - Highlight your activity',
    text3: 'Thanks to our feature, manage your posts from a single place and distribute them on the 3 largest media: \n Google, Facebook and Instagram.',
    keywordText3: 'Artificial Intelligence ',
    suiteText3: 'gets involved and helps you produce varied and quality content.\n',
    text4Bold: '3 - Keep in touch with your community and manage your e-reputation',
    text4: 'In addition to keeping your users and potential customers informed, maintain a permanent link with them, be alerted when they leave you a comment on Google and Facebook. Artificial Intelligence accompanies you to answer as accurately and in a personalized way.',
    text5Bold: '4 - Organize and anticipate your communication',
    text5: 'A scheduling tool allows you to streamline your media presence and save valuable time.',
    text6: 'So it\'s time to stick to the uses of customers who are looking for you on the Internet and social networks. \not',
    text7: 'In short, with our local SEO solution, ',
    cashPhrase: 'we seek you, we find you!',
    beContacted: 'Be contacted by an advisor',
    alreadyClient: 'You already have an account ? Log in to your customer space.',
    emailSubject: 'Client {{advertiser}} : Se faire connaitre - Contact Request',
    emailContent: 'The client {{advertiser}} ({{companyName}}) sent a contact request from the new ' +
        'customer space for the product "Se faire connaitre". You may contact him ' +
        'via {{email}} or at this number {{phoneNumber}}',
    dialogMessage: 'You requested more information about our product "Se Faire Connaître". Our team will contact you as soon as possible.',
    txtAccesTeteDeReseau: '<p class="text-justify">Your network has a subscription to the solution "Se Faire Connaïtre".</p>' +
        '<p class="text-justify">But the management of this subscription and the access to the interface "Se Faire Connaïtre" are limited to your head of network.</p>' +
       '<p class="text-justify">So, your point of sell can not access it. For any question, please contact direclty your head of network.</p>'
  },
  socialNetworkPosts: {
    title: 'Post Management',
    text1: 'Thanks to our distribution offer on social networks and Google My business: \n',
    text2: 'Optimize content on the first social networks and the first media,',
    text3: 'Improve the natural referencing of your site and visits to your points of sale,',
    text4: 'Develop your community, new points of interaction and thus new business opportunities,',
    text5: 'Distribute your ad portfolio more widely,',
    text6: 'And enhance your classified ads in accordance with the best practices appreciated by each of the media.',
    text7: 'What media are they?',
    beContacted: 'Are you interested and want to know more? Be contacted by your sales representative.',
    emailSubject: 'Client {{advertiser}}: Social networks - New contact request from the Customer Area',
    emailContent: 'The customer {{advertiser}} ({{companyName}}) made a request from his customer area. He wants more information about our social network offer and asks to be contacted by the sales representative following his file. ',
    dialogMessage: 'Would you like information on our post management solution? Our team will contact you as soon as possible.',
    alreadyClient: 'Already equipped with the solution? Access the page for managing your advertisements.',
    operationDisabledFlux: 'Operation not available because the post was created by your software'
  },
  validator: {
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required',
    passwordConfirmationRequired: 'Password confirmation is required',
    passwordMustBeEquals: 'Passwords must be identical',
    plate: {
      letterIandOnotAllowed: 'Letters I and O are not allowed.',
      invalid: 'The plate number is not valid.',
      sivFormat: 'After 2009, the plate number must respect the SIV format (AA-999-BB)',
      sivOrFniFormat: 'The plate number must respect the FNI format (1234 AB 35) or the SIV format (AA-999-BB)'
    },
    alertMandatoryFields: 'Please fill all necessary fields',
    offerTypeRequired: 'Offer type is required',
    propertyTypeRequired: 'Property type is required',
    referenceRequired: 'Reference is required',
    referenceMustBeWithoutAccentAndSpecialCharacter: 'The reference is not valid. Accents and special characters are not accepted.',
    titleRequired: 'Title is required',
    priceRequired: 'Price is required',
    priceMustBeNumber: 'Price must be a number',
    monthlyRentRequired: 'Montly rent is required',
    monthlyRentMustBeNumber: 'Montly rent must be a number',
    showPriceRequired: 'Indicate if you want to show the price',
    textRequired: 'Ad description is required',
    textAtLeast: 'A minimum of {{ number }} characters is required',
    realPostalCodeRequired: 'The real postal code is required',
    realCityRequired: 'The real city is required',
    postalCodeRequired: 'Postal code is required',
    cityToShowRequired: 'City is required',
    mustBeNumber: 'This field must be a number',
    mustBeNumericValue: 'This field must be a numeric value',
    serialNumberAtLeast: 'Serial number must contain {{ number }} characters',
    brandRequired: 'Brand is required',
    modelRequired: 'Model is required',
    yearRequired: 'Year is required',
    versionRequired: 'Version is required',
    mileageRequired: 'Mileage is required',
    energyRequired: 'Energy is required',
    offerTitleMax: 'maximum {{ number }} characters',
    corporateNameRequired: 'Corporate name is required',
    wrongFormat: 'Wrong format',
    httpOrHttps: 'This field must start with http:// or https://',
    referenceAlreadyExists: 'The reference of your ad already exists',
    enterReference: 'Please enter a reference',
    validEmail: 'This field must be a valid email.',
    addDelete: 'Your ads have been deleted',
    addDuplicate: 'Your ad has been duplicated',
    addUpdate: 'Your ad has been updated',
    addMerge: 'Your ad has been created',
    isRequired: 'This field is required',
    errorReferenceExceed: 'Your ad reference cannot exceed 50 characters.'
  },
  error: {
    unknown: 'An unknown error has occurred.',
    found: 'An error has been found',
    gif: 'GIF format is not accepted',
    formatImage: 'Format {{ format }} is not accepted'
  },
  components: {
    lists: {
      resultsPerPage: 'Results per page : ',
      sortByPlaceholder: 'Sort by...',
      sortByLabel: 'Sort by {{ label }}',
      resultsFromTo: 'Results {{ from }} to {{ to }} on {{ total }}',
      noResult: 'no result',
      loading: 'Loading...',
      eraseSelection: 'Erase the selection',
      selectAll: 'Select All',
      columnThumbnails: 'Pictures',
      valide: 'Valid',
      diffusee: 'Broadcast',
      errorOnLoading: 'An error occurred while loading this page'
    },
    card: {
      activated: 'Activated',
      deactivated: 'Deactivated',
      postFlux: 'This ad must be deleted in your software and not from your Ubiflow Customer Space.',
      draft: 'Draft',
      model: 'MODEL',
      CreatedOn: 'Created on',
      updatedOn: 'Updated on'
    },
    searchContainer: {
      hideFilters: 'Hide filters',
      showFilters: 'Show filters',
      search: 'Search',
      orFilterBy: 'or filter by :',
      advancedSearch: 'Advanced search'
    },
    facebook: {
      label: 'Facebook connection'
    }
  },
  posts: {
    list: {
      pageTitleLots: 'List of lots',
      pageTitlePrograms: 'List of programs',
      pageTitleAds: 'List of ads',
      backToProgramList: 'Back to program list',
      backToAdsList: 'Back to program list',
      backToPostsList: 'Back to list of posts',
      createLot: 'Create a lot',
      createProgram: 'Create a program',
      createAd: 'Create an ad',
      createAdFromModel: 'Create an ad from a model',
      createProgamFromModel: 'Create a program from a model.',
      createlotFromModel: 'Create a lot from a model',
      createLand: 'Create a land',
      createModel: 'Create a model',
      createPost: 'Create a post',
      filenameExportAds: 'list_ads',
      delete: 'delete',
      postsCity: 'Ciudad',
      diffuseLater: {
        title: 'Schedule the diffusion of your ad',
        text: 'On what date would you like to schedule your diffusion?',
        subText: 'If you want to diffuse your ad now, active it from the ad list.',
        diffusedAt: 'Diffusion on :',
        diffusionConfirmedFirstPart: 'Your ad will be diffuse on ',
        diffusionConfirmedSecondPart: '. Meanwhile, it will be saved as draft and still be editable. You will be redirected to your ad list.',
        planDiffusion: 'Schedule diffusion',
        reportDiffusion: 'Modify the schedule'
      },
      contentLibrary: 'My content library',
      informationBienVendu: 'Information on the property sold',
      declarePostAsDeleteByNo: 'No, delete the good',
      declarePostAsSoldByYes: 'Yes, I sold the good',
      bienVendu: 'Sold Good',
      confirmBienVendu: 'Confirm the entry of your property sold?',
      newBienVendu: 'Create a sold good',
      daysRemaining: 'days remaining',
      commercial: 'Commercial',
      nbAnnonces: 'Active ads',
      annoncesActivesDecroissantes: 'ads descending',
      annoncesActivesCroissantes: 'ads ascending',
      commercialDecroissant: 'commercial descending',
      commercialCroissant: 'commercial ascending',
      graphAnnoncesCommerciauxTitle: 'Distribution of the number of active ads by sales representatives',
      graphAnnoncesCommerciauxNoData: 'No data',
      graphAnnoncesCommerciauxSubtitle: 'Active ads'
    },
    dialog: {
      duplicateTitle: 'Duplicate your ad',
      duplicateText: 'Are you sure that you want to duplicate your ad ?',
      duplicateReference: 'Enter a reference for your duplicated ad (optional) : ',
      duplicatePlaceholder: 'Enter a reference for your duplicated ad (optional)',
      duplicateNotificationSuccess: 'Your ad has been successfully duplicated with the reference {{ reference }}',
      duplicateNotificationError: 'An error occured during the duplication of your ad',
      deleteTitle: 'Delete your ad',
      deleteText: 'Are you sure that you want to delete your ad ?',
      deleteTextSoldProductOption: 'You want to remove this classified ad. Was this property sold by you?',
      deleteNotification: 'Your ad has been successfully deleted',
      modelDeleteTitle: 'Delete model',
      modelDeleteText: 'Are you sure that you want to delete this model ?',
      selectModelTitle: 'Select among your following models',
      selectModelTitleCmiste: 'Would you like to use a model to create your ad?',
      selectModel: 'Select a model',
      selectModelProgram: 'Or select a program',
      selectTerrain: 'Select a land',
      selectListTerrain: 'Selected from your list of land',
      selectListModel: 'Selected from your list of land',
      propertyType: 'Select a property type',
      createFromModelTitle: 'Create an ad from this model',
      createFromModelText: 'Are you sur that you want to create an ad from this model ?',
      selectReference: 'Enter a reference for your created ad ',
      selectReferencePlaceholder: 'Enter a reference for your created ad',
      textCreateLot: "Pour créer un lot, veuillez choisir le programme auquel le rattacher dans la liste ci-dessous puis cliquer sur le bouton \"Gérer les lots. Vous aurez ensuite la possibilité de créer un lot à partir d'un modèle, retourner à la liste des programmes, créer un nouveau lot et consulter la liste des lots déjà rattachée à ce programme.",
      confirm: 'Confirm',
      delete: 'Delete',
      cancel: 'Cancel',
      selectProgram: 'Please choose the program to which you wish to attach your lot.',
      choiceOfProgram: 'Program selection',
      lengthSelectedExceeded: 'The length of your selection exceeds {{length}} classified ads',
      archiveMyPost: 'Archive my classified ad',
      dontDisplayAnymore: 'Do not display anymore',
      close: 'Close',
      unPublishNOK: 'Your classified ad must be unpublished before you can permanently archive it.',
      archiveConfirm: 'The archiving of a classified ad of property sold is final and irreversible. The classified ad will no longer be accessible in your Customer Area. Do you confirm the archiving of this classified ad?'
    },
    card: {
      model: 'Model',
      ref: 'Ref',
      actionsOnThisAd: 'Actions on this ad',
      seeLots: 'See lots',
      manageLots: 'Manage lots',
      details: 'Details',
      edit: 'Edit',
      diffuse: 'Diffuse',
      duplicate: 'Duplicate',
      useThisModel: 'Use this model',
      useThisLand: 'Use this land',
      presenceReport: 'Presence report',
      delete: 'Delete',
      contacts: 'Contacts',
      privateNote: 'Private note',
      managePosts: 'Posts',
      noData: 'No data available at this time...',
      selectAll: 'Select all',
      deSelectAll: 'Unselect all',
      reference: 'Reference',
      title: 'Title'
    },
    components: {
      picturesTitle: 'Pictures',
      picturesText: 'Manage here the pictures of your property. <strong>The first activated image corresponds ' +
          'to the main image of your ad and when posting on social media.</strong>',
      picturesButton: 'Add one or more pictures',
      picturesDialogTitle: 'Select the origin of the pictures to add...',
      picturesDialogTextTop: 'From your computer or from your mobile device',
      picturesDialogTextMiddle: '<em>Click here</em> or drag/drop the files',
      picturesDialogTextBottom: 'Jpg/png files with a size less than 10Mo <br> maximum 50 pictures',
      picturesButtonCancel: 'Cancel',
      picturesButtonAdd: 'Add pictures',
      picturesButtonDelete: 'Delete',
      otherMediasTitle: 'Additional media',
      otherMediasText: 'Enter the information regarding your additional medias.',
      otherMediasVirtualVisit: 'Virtual visit',
      otherMedias: 'Other media',
      otherMediasTxt: 'Add an URL that redirects to another online medium (animation, video, ...)',
      otherMediasVirtualVisitText: 'Add an url to a page that presents a virtual visit of the property',
      otherMediasTestLink: 'Test the link',
      otherMediasAttachedFiles: 'Attachments',
      otherMediasAttachedFilesText: 'Add attachments from your computer or mobile device',
      otherMediasAttachedFilesButton: 'Add an attachment',
      customizedFormElement: 'Custom form element',
      postalCodePlaceholder: 'Ex : 97132',
      cityPlaceholder: 'Ex : Issy-les-Moulineaux',
      adPerformance: 'Ad performance',
      forMoreInformation: 'For more information contact ',
      urlVideo: 'Video URL'
    },
    edit: {
      achat: 'Purchase',
      loa: 'Lease with option to buy',
      lld: 'Long term rental',
      loyerMontantVo: 'The rent',
      dureeLocationLoa: 'Rental period',
      kilometrageMaxLoa: 'Maximum mileage',
      kilometrageAutomatic: 'For new vehicles, the kilometrage is automatically set to 0.',
      financementApport: 'Contribution amount',
      servicesInclusLoyer: 'Services included in the rent',
      urlMentionsLegalesLoa: 'Legal notice URL link',
      legalNotices: {
        dialogDeleteTitle: 'Delete selected legal notices',
        dialogDeleteText: 'Are you sure that you want to deleted these legal notices ?',
        dialogUpdateTitle: 'Modify selected legal notices model',
        dialogUpdateNoticesTitle: 'Title of your legal notices',
        dialogUpdateNoticesText: 'Text of your legal notices',
        dialogButtonCancel: 'Cancel',
        dialogButtonConfirm: 'Confirm',
        dialogButtonUpdateOnlyForThisAd: 'Use only for this ad',
        dialogButtonUpdateModel: 'Update your model',
        title: 'Offer legal notices',
        description: 'To add legal notices to your ad, select among the existing model list ' +
            'or create new legal notices that you can also save as new model.',
        chooseModel: 'Select a model',
        chooseModelPlaceholder: 'Select in your list of legal notices',
        buttonUse: 'Use',
        buttonSave: 'Save',
        buttonEdit: 'Edit',
        tooltipUse: 'By clicking "Use" you will use these legal notices for your current ad. ',
        tooltipSave: 'By clicking "Save", you will use these legal notices for your current ad ' +
            'and save them as new model.',
        selectedNoticesText: 'Text of the selected legal notices',
        orCreateNoticesText: 'Or create your legal notices',
        newNoticesTitle: 'Title of your legal notices',
        newNoticesText: 'Text of your legal notices',
        messageSuccess: 'The legal notices has been successfully added to the text of your ad that you can see in the tab ' +
            '"Main information". Please verify them before validating your ad for diffusion',
        messageDeleteSuccess: 'Selected legal notices has been successfully deleted',
        messageDeleteError: 'An error occurred during the deletion of your legal notices',
        messageEmptySelection: 'You did not selected any legal notices',
        messageUpdateError: 'An error occurred during the update of your legal notices'
      },
      publish: 'Published',
      now: 'Now',
      scheduled: 'Scheduled',
      spread: 'Broadcast',
      deleteSchedule: 'Delete schedule',
      beneficieTVA7: 'Benefit from 7% VAT',
      beneficieTVA5: 'Benefit from 5.5% VAT',
      save: 'Save',
      saveModifications: 'Save changes',
      saveDraft: 'Save as draft',
      createModel: 'Create as model',
      createAsLand: 'Create as land',
      deleteModel: 'Delete model',
      deleteLand: 'Delete land',
      cancel: 'Cancel',
      pageTitleLot: 'Create a lot',
      pageTitleProgram: 'Create a program',
      pageTitleModele: 'Edit a template',
      pageTitleAd: 'Create an ad',
      alertBeforeLeave: 'Are you sure that you want to leave your ad edition ? All the information will be lost.',
      mainInformationTitle: 'Main information',
      fuel: 'fuel',
      electric: 'electric',
      moreInformationTitle: 'Complementary information',
      mainInformationText: 'All fields are required. They help to determine the principal characteristics of ' +
          'your ad. <br><br> Fill the following fields in order to publish your ad :',
      offerType: 'Offer type',
      propertyType: 'Property type',
      reference: 'Ad reference',
      tooltipReference: 'Caution: in order to respect the publication rules of our partners, we suggest you ' +
          'not to use more than 20 characters for this reference.',
      tooltipEquipementsAndOptions: 'Caution: equipments must be entered manually using the list provided. ' +
          '<br/> The purpose of this field is to complete the above elements. ' +
          '<br/> Please enter each label separating them by a comma. ' +
          '<br/> Please do not enter sentences, copy and paste, or use other punctuation.',
      title: 'Ad title',
      vehiculeImporte: 'Let you indicate that it is an imported vehicle and enter a foreign registration plate.',
      informationsComplementaires: 'This field should not contain the equipment, but additional information such as services upon purchase, details on costs during the sale, or information on the point of sale',
      price: 'Price',
      priceIncludingVAT: 'Price including VAT',
      priceExcludingVAT: 'Price without tax',
      rent: 'Rent',
      obligationToClearBrush: 'Obligation to clear brush',
      description: 'Description',
      adText: 'Ad text',
      vehicleType: 'Vehicle type',
      warranty: 'Warranty',
      location: 'Location',
      locationProximityAndSituation: 'Proximity and situation',
      locationPropertyTitle: 'Property location',
      locationPropertyText: 'Enter the property address and also the location as you would like to see it on the ' +
          'ads. <br><br> Caution : enable the communication of the exact address only if you have respected some rules.',
      programType: 'Program type',
      selectTypePlaceholder: 'Select a type...',
      linkToProgramOnline: 'Link to the program online',
      showPriceTooltip: 'If you do not want to show the price of your property, click on "no" and it will be shown "consult us"',
      typeLand: 'Land',
      typeLandHouse: 'Land + house program',
      mergeFromModels: 'Create from content library',
      address: 'Address',
      programAddressTitle: 'Program address',
      programAddressText: 'Enter the program location as you would like to see it on the ' +
          'ads. <br><br>Caution : enable the communication of the exact address only if ' +
          'you have respected some rules.',
      exactAddressTooltip: 'If you check Yes, the exact address of your property will be visible on the ad. ' +
          'Otherwise, we can mention only the city.',
      locationToPublishTitle: 'Location to publish',
      locationToPublishTooltip: 'This information will be published on the portals, allowing the geolocalization of your ad.',
      locationToPublishTooltipVo: "The information 'Postal code' and 'city' allow a better" +
          '<br/>geolocalization enrichment of your ad but will not be' +
          '<br/>published by the portals. You can fill these fields if the information is different that the information' +
          '<br/>you want to publish on internet',
      interiorTitle: 'Interior',
      interiorServices: 'Interior services',
      otherInteriorServices: 'Other interior services',
      exteriorServices: 'Exterior services',
      exactAddressTitle: 'Exact address',
      saleDetailsTitle: 'Sale details',
      target: 'Target',
      virginDPEMessage: 'Exceptionally […] in the justified absence of consumption readings, required elements […] must stay virgin.',
      contactTitle: 'Contact information',
      contactText: 'Indicate the contact information you would like to show.',
      contactFirstnameLastname: 'Firstname/Lastname',
      internationalTitle: 'International',
      saleTitle: 'Property sale request',
      saleTitleShort: 'Sale',
      saleNewTitle: 'Sale new',
      leaseTransferTitle: 'lease transfer',
      goodwillTitle: 'Goodwill',
      tariffTitle: 'Tariff',
      auctionsTitle: 'Auctions',
      rentalTitle: 'Rental',
      saleRentalTitle: 'Sale or rental',
      fillAdPriceDetails: 'Fill the price details of your ad.',
      copropertyTitle: 'Co-property',
      fillCopropertyInformation: 'Fill the necessary information if the property is subject to co-property status.',
      mandateTitle: 'Mandate',
      fillMandateInformation: 'Fill the necessary information regarding the mandate for this property.',
      equipmentsAndOptionsTitle: 'Equipments and options',
      equipmentsAndOptionsText1: 'To enrich your ad, you can select equipments and options among the following customizable list or use the free field.',
      equipmentsAndOptionsText2: 'Suggestions will appear automatically according to the first letters of your search.',
      vehicleDescriptionLBC: 'This field is specific to the Le Bon Coin distribution which now allows the publication of a free description of the vehicle',
      lookForEquipmentPlaceholder: 'Look for an equipment',
      seeAvailableEquipmentsList: 'See the list of available equipments',
      customizeFavoriteEquipment: 'Customize favorite equipment',
      availableEquipmentsList: 'list of available equipments',
      maxFavoriteEquipments: 'Number of equipment selected as favorites',
      maxFavoriteEquipmentsTip: 'Max {{ max }}',
      otherInformation: 'Other information',
      tabMain: 'Main information',
      tabDetail: 'Offer detail (price, mandate...)',
      tabDetailProgram: 'Program detail',
      tabEquipments: 'Equipments and options',
      tabDescription: 'Property description',
      tabMedias: 'Medias (Pictures, videos...)',
      tabInstagram: 'Instagram diffusion',
      tabLegalNotices: 'Legal notices',
      tabInternational: 'International (translated texts)',
      tabParametres: 'Ad Settings',
      copropertyAverageAnnualFee: 'Average annual amount of co-property fee',
      copropertyMonthlyFee: 'Monthly amount of condominium fees',
      intercabinetCommission: 'Intercabinet commission',
      withoutCivilityAndName: '(without civility and without firstname)',
      landlordAddress: 'Landlord address',
      landlordOtherInformation: 'Other information',
      realPropertyPostalCode: 'Real postal code of the property',
      realPropertyCity: 'Real city of the property',
      goodwillPrice: 'Goodwill price',
      goodwillWallsRental: 'Goodwill walls rental',
      landPricePart: 'Land price part',
      ancillaryCostsPart: 'Ancillary costs part',
      includingTaxes: 'including VAT',
      recoveryCondition: 'Recovery condition',
      rentalFeeIncludingConditionInspection: 'Rental fee (including condition inspection)',
      linkToAgencyFees: 'Link to agency fees',
      collateralSecurityRequired: 'Collateral security required',
      seller: 'Seller',
      buyer: 'Buyer',
      costsWillBeBorneBy: 'Costs will be born by...',
      sellerShare: 'Seller share',
      buyerShare: 'Buyer share',
      package: 'Package',
      monthlyAnnuity: 'Monthly annuity',
      land: 'Land',
      checkboxLandWithSlope: 'With slope',
      checkboxLandServiced: 'Land serviced',
      checkboxLandAllotment: 'Land allotment',
      checkboxLandBuildable: 'Land buildable',
      propertyPartnerCompany: 'Company',
      propertyPartnerLastname: 'Contact lastname',
      propertyPartnerFirstname: 'Contact firstname',
      propertyPartnerPhone: 'Phone',
      checkboxAirport: 'Airport',
      checkboxHighwayExit: 'Highway exit',
      checkboxGare: 'Gare',
      checkboxBus: 'Bus',
      checkboxTramway: 'Tram / tramway',
      checkboxParking: 'Parking',
      checkboxShops: 'Shops',
      checkboxMall: 'Mall',
      checkboxDowntown: 'Downtown',
      checkboxNursery: 'Nuersery',
      checkboxPrimarySchool: 'Primary school',
      checkboxCollege: 'College',
      checkboxHighSchool: 'High school',
      checkboxUniversity: 'University',
      checkboxGreenSpaces: 'Green spaces',
      checkboxSubway: 'Subway',
      cd: 'CD player',
      agencyFee: 'Agency fee',
      diffuseNow: 'Save and diffuse',
      diffuseLater: 'Save and schedule my diffusion',
      adSaved: 'The information of your ad has been saved. Your ad will be diffused on ',
      redirect: 'You will be redirected to your ad list.',
      adManagerTitle: 'Ad manager',
      adManagerText: 'Please select the person in charge of this announcement from the drop-down list. ' +
          '<br> If the person to whom you want to assign this ad is not present in the list, ' +
          'either it is because it does not have the necessary access rights to the Customer Area, ' +
          'or you must add it to your contact book.',
      user: 'User',
      createLand: 'Create a land',
      model: 'Model',
      selectLand: 'Select a building land model',
      selectModel: 'Select a building house model',
      instagramSubtitle: 'Edit from this tab the content to be diffused on your Instagram post.' +
          '<br><br>We have content for you to distribute that you can modify. ' +
          'You can also come back to it by clicking on the "Re-generate" button.' +
          "<br><br>Only your main visual from the 'Media' tab can be diffused<br><br><strong>ATTENTION</strong><br>",
      networkTextFormat: 'The format of your visuals must be adapted for this social network.',
      instagramTextPost: '<strong>Once your post has been broadcast, its content will no longer be editable or deletable from your Ubiflow Customer Space.</strong>',
      instagramCaption: '2200 characters maximum, including your # (30 maximum), @ (20 maximum) and the link of the ad. ' +
          'For this latter, we suggest you to use a short url, Google URL Shortener is a good tool for that.',
      alreadyBroadcastedToInstagram: 'Your ad has beed diffused to your Instagram account. Its content can no longer be modified.',
      shortDescription: 'Short description',
      tooltipTexteResume: 'This description will be also considered in you diffusion to Google My Business if you have it in your subscription.',
      generateInstagramCaption: 'Re-generate',
      generateCaption: 'Re-generate',
      resetCaption: 'Reset',
      instagramOptionDisabled: 'The diffusion of your ads on Instagram is not enabled. To do this, contact us on 02 99 83 05 36.',
      GMBOptionDisabled: 'The distribution of your ads on Google My Business is not activated. For this, contact us at 02 99 83 05 36.',
      surfaceHabitable: 'Living surface ',
      surfaceCommerciale: 'Sales area',
      surfaceActivite: 'Activity area',
      surfaceLand: 'Land surface ',
      promoterProgram: 'Real estate program',
      miseEnCirculation: 'Release',
      carDoorsAfter: ' doors',
      warrantyTime: 'Guarantee period',
      idRPLS: 'RPLS number',
      location_active: 'Active rental',
      location_active_nud: 'Localisation active vérification NUD',
      editPostNonEditablesFieldsImmo: 'The following elements cannot be modified during input:<br>' +
          '<br><ul>' +
          '<li>Offer type</li>' +
          '<li>Property type</li>' +
          '<li>Reference</li>' +
          '<li>Ad title</li>' +
          '<li>Ad text</li></ul>',
      editPostNonEditablesFieldsVo: 'The following elements cannot be modified during input:<br>' +
          '<br><ul>' +
          '<li>Reference</li>' +
          '<li>Vehicle type</li></ul>',
      changeMassContactsTitle: 'Selected from the dropdown list the contact you want to enter for the selected ads:',
      commercialEntityCode: 'Business entity code',
      formBienVenduTitle: 'Information regarding the sale of the property',
      formBienVenduAnnonceTitle: 'Information concerning the announcement of the property',
      bienVenduSubtitle: 'From this tab, fill in the main information on the property you have sold.<br>' +
          '<br>' +
          'If you wish to communicate on this property sold, Ubiflow offers you for each of your social networks, a post automatically generated on the basis of this data and that of your ad. <br>' +
          '<br>' +
          'You can edit this data and personalize posts before they are published on your networks.<br>',
      prixVenduNet: 'Net sold price',
      GMBTitle: 'Information to post on Google My Business',
      GMBSubtitle: 'Edit your post from this tab as you want it to appear on your Google My Business page.\r\n' +
          '<br><br>' +
          'Ubiflow offers you an automatically generated post based on your ad data.\n' +
          'You can edit it before it is published.',
      GMBSubtitle2: 'Edit your post from this tab as you want it to appear on your GMB business listing.<br><br>Ubiflow offers you an automatically generated post based on your ad data.<br>You can edit it before it is published.',
      creationBienVendu: 'Creation of a sold property',
      creationBienVenduDialogCaption: 'The seizure of information concerning the sale of a property, automatically leads to the depublication' +
          ' the announcement of the property on the various distribution portals, if the latter was published.',
      infoGeoRisques: 'Risk Information',
      geoRisquesSubtitle: 'A decree applicable on 01/01/2023 provides that the announcement relating to the sale or rental of property for which the statement of risks mentioned in Article L. 125-5 must be established, regardless of its dissemination medium, includes the following statement: Information on the risks to which this property is exposed is available on the Georisks website: <a href="https://www.georisques.gouv.fr" target="_blank">www.georisques.gouv.fr</a>',
      typeTransmission: 'Drive type',
      instagramMaxHashtagExceeded: 'You have exceeded the number of authorized hashtags',
      instagramMaxMentionsExceeded: 'You have exceeded the number of mentions allowed',
      chars: 'characters',
      visite: {
        title: 'Visits',
        description: '',
        duree_publication: 'Publication duration',
        heures: 'hours',
        lieu_visite: 'Visiting location',
        commentaire: 'Comment',
        visite: 'Visit',
        dateDebut: 'Date of the visit',
        horaire: 'Tour schedule',
        nombre_candidats_max: 'Maximum number of visitors',
        saveVisite: 'Save visit',
        nombre_candidats_inscrits: 'Number of registered candidates',
        status: 'Visit status',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        confirmationAnnulationTitle: 'Cancel the visit',
        confirmationAnnulationText: 'Would you like to cancel this tour ?',
        annuler: 'No',
        confirmer: 'Yes'
      },
      activitesCommercePlaceholder: 'Choose an activity',
      affichage_privilegie: 'Crush',
      securiteBien: 'Security of the property',
      systemeIncendie: 'Fire system'
    },
    view: {
      edit: 'Edit',
      sendByEmail: 'Send by email',
      sendByEmailTitle: 'Transfer this ad by email',
      sendByEmailRecipient: 'Recipient address',
      sendByEmailMessage: 'Your message',
      sendByEmailComment: 'Your ad attached',
      sendByEmailSubject: 'Your ad {{ postTitle }}',
      sendByEmailAttachment: 'Ad-{{ reference }}.pdf',
      cancel: 'Cancel',
      send: 'Send',
      goBackTitleLots: 'Go back to the list of lots',
      goBackTitlePrograms: 'Go back to the list of programs',
      goBackTitleAds: 'Go back to the list of ads',
      pageTitleLot: 'detail of a lot',
      pageTitleProgram: 'Detail of a program',
      pageTitleAd: 'Detail of an ad',
      print: 'Print',
      printFilename: 'My_Ad.pdf',
      name: 'Name : {{ name }}',
      city: 'City : {{ city }}',
      cityPromoteur: 'City : ',
      price: 'Price : {{ price }} {{ currency }}',
      priceMin: 'Price : from {{ price }} {{ currency }}',
      priceLowSeason: 'Weekly price low season : {{ price }} {{ currency }}',
      priceMiddleSeason: 'Weekly price middle season : {{ price }} {{ currency }}',
      priceHighSeason: 'Weekly price high season : {{ price }} {{ currency }}',
      monthlyRentChargesIncluded: 'Monthly rent charges included',
      monthlyRentChargesIncludedDisplay: '€ / month ic',
      priceContactUs: 'Price : Consult us',
      surfaceMinMax: 'Surface : from {{ min }}m² to {{ max }}m²',
      surface: 'Surface : {{ surface }}m²',
      roomsNumber: 'Number of rooms : {{ number }}',
      offerTypeV: 'Offer type : Sale',
      contactTitle: 'Contact information',
      saleConditionsPrice: 'Price',
      saleConditionsPriceVo: 'Price : {{ price }} {{ currency }}',
      saleConditionsLand: 'of which land price',
      saleConditionsBuyerFee: 'Buyer fee including VAT',
      gearsNumber: '{{ number }} gears',
      selectionVoMarchand: 'Merchant',
      selectionVo: 'VO selection',
      goBackTitleSelectionVo: 'Return to the VO selection list',
      contacter: 'Contact',
      sousGarantieConstructeur: 'Under manufacturer\'s warranty',
      contacterVendeur: 'Contact seller',
      emailReplyTo: 'Reply email address',
      selectionVoEmailComment: 'Hello, I am interested in the reference vehicle \'{{ postRef }}\'',
      pricePublic: 'public price',
      priceDealer: 'market price',
      portalLink: 'Portal link',
      depotGarantie: 'Deposit guarantee',
      honorairesLocation: 'Rental fees'
    },
    bienVendu: {
      createWarning: 'The entry of information concerning the sale of a property automatically leads to the depublication of the announcement of the property on the various distribution portals, if the latter was published.',
      formDialogCreateTitle: 'Creation / recording of modifications to the property sold in progress',
      dialogConfirmBVCreationTitle: 'Confirm the creation of your sold property',
      cancelCreationBienVenduTitle: 'Cancel the entry of your property sold',
      modificationSuccess: 'Your modification was saved successfully',
      creationSuccess: 'Your creation has been successfully saved',
      creationFailed: 'Your creation failed',
      dialogConfirmBVChangeTitle: 'Creation / recording of modifications of the current sold asset',
      cancelCreationBienVenduText: 'Are you sure you want to leave the seizure of your property sold? All the information entered in the different tabs will then be lost.',
      formCreation: {
        initialPrice: 'Initial price *',
        livingSpace: 'Living space',
        roomsNumber: 'Number of pieces',
        energyConsumption: 'Energy consumption',
        streetNumber: 'Lane number',
        streetType: 'Lane type',
        streetName: 'Name of the lane',
        postalCode: 'Postal code *',
        city: 'City *',
        salesAgreementDate: 'Compromise date',
        buyerOrigin: 'Origin of the buyer',
        chooseOrigin: 'Choose an origin',
        saveAndClose: 'Save and close',
        saveAndManagePosts: 'Save and customize posts',
        saveAndManageDiffusion: 'Save and manage the broadcast',
        buyerFees: 'Buyer fees',
        sellerFees: 'Seller Fees'
      }
    },
    report: {
      sendByEmail: 'Send by email',
      print: 'Print',
      goBackToAdList: 'Go back to the list of ads',
      dialogTitle: 'Tranfer this ad by email',
      dialogEmail: 'Recipient address',
      dialogMessage: 'Your message',
      dialogMessagePlaceholder: 'Your presence report attached',
      dialogCancel: 'Cancel',
      dialogSend: 'Send',
      city: 'City',
      price: 'Price',
      yourAdHasBeDiffusedTo: 'Your ad has been sent to',
      yourAdIsOnlineOn: 'Your ad is online on',
      portals: 'portals',
      reportDate: 'Your presence report as of',
      definition: 'Definition of the terms used here',
      online: 'Online',
      onlineText: 'Ubiflow verifies that your ad is currently online on the portal.',
      diffused: 'Diffused',
      sent: 'Sent',
      diffusedText: 'your ad has been sent to the portal. But the portal do not communicate any proof of publication to Ubiflow.',
      pdfName: 'My_Report',
      emailSubject: 'Your report for the ad {{ title }}',
      emailAttachmentFirstPart: 'Report-',
      globalTitle: 'General statisticsMeta',
      lastIntegration: 'Date of last integration',
      adsIntegrated: 'Number of ads integrated',
      adsDeleted: 'Number of ads deleted',
      exportResults: 'Export results',
      columnAd: 'Ad',
      columnDateCreation: 'Date of creation',
      columnDateModification: 'Date of modification',
      columnPictures: 'Nb. pictures',
      filenameExportIntegration: 'export_report_integration',
      filterRejected: 'Rejected ads',
      filterWarn: 'Warning',
      numberCountERROR: 'Number of error messages',
      numberCountWARN: 'Number of warning messages'
    },
    privateNote: {
      postReference: 'Reference',
      postPrice: 'Price',
      postLocation: 'Location',
      postSurface: 'Surface',
      PostNumberRoom: 'Number of rooms',
      generalInformationTitle: 'General information',
      postPrivateNote: 'Private note of the ad',
      postBrand: 'Brand',
      postModel: 'Model',
      postEnergie: 'Energy',
      contenueNote: 'Content of the note',
      messageSucces: 'Your note has been successfully updated'
    },
    linkedIn: {
      asideTitle: 'Information to share on LinkedIn',
      asideText: 'Edit from this tab the content to broadcast on your LinkedIn post.<br><br>' +
        'We offer content to broadcast as your LinkedIn post.<br><br>' +
        'We offer content to broadcast that you can modify by integrating emojis and change text elements. You can also return to it by clicking on the "Re-generate" button.<br><br>' +
        'You can also broadcast several integrated visuals from the "Media" tab<br><br>' +
        'ATTENTION<br><br>' +
        'A once your post is broadcast, its content will only be editable by integrating emojis and changing text elements. You can also return to it by clicking on the "Re-generate" button.<br><br>' +
        'You can also broadcast several integrated visuals from the "Media" tab<br><br>' +
        'ATTENTION<br><br>A Once your post has been broadcast, its content will no longer be editable or deletable from your Ubiflow Customer Space.\n',
      notActivated: 'The distribution of your ads on LinkedIn is not activated. For this, contact us at 02 99 83 05 36.',
      generate: 'Regenerate'
    },
    descriptionTitle: 'Description',
    offerDescription: 'Offer description',
    vehicleDescription: 'Vehicle description ',
    offerType: 'Offer type',
    propertyType: 'Property type',
    priceWithoutTaxes: 'Price (without taxes)',
    ancillaryCosts: 'Ancillary costs',
    defiscTitle: 'Investments benefits',
    offerTitle: 'Offer',
    offerDetail: 'Offer detail',
    certificationsAndLabelsTitle: 'Certifications and labels',
    energyTitle: 'Energy, heat',
    heatTitle: 'Heat',
    exteriorTitle: 'Exterior',
    interiorTitle: 'Interior',
    propertyDescriptionTitle: 'property description',
    environmentTitle: 'Environment',
    idSite: 'Website id',
    urlAnnonceSiteAnnonceur: 'Url on your website',
    informationsComplementaires: 'Additional information',
    titreMetaWeb: 'Metadata "title" of the website',
    descriptionMetaWeb: 'Metadata "description" of the website',
    pushMenu: 'Push menu',
    coupDeCoeur: 'Favorite',
    addVisiteVirtuelle: 'Add a virtual tour',
    propertyConditionTitle: 'Property condition',
    coPropertyInformationTitle: 'co-property information',
    propertyPartnerTitle: 'Property partner',
    dpeTitle: 'DPE',
    securityDeposit: 'Security deposit',
    myAd: 'My ad',
    saleConditionsTitle: 'Sale conditions',
    complementaryInformationTitle: 'Complementary information',
    equipments: 'Equipment',
    comfortEquipmentsTitle: 'Comfort equipments',
    securityEquipmentsTitle: 'Security equipments',
    otherEquipmentsTitle: 'Other equipments',
    generalInformationTitle: 'General information',
    houseTitle: 'House',
    landTitle: 'Land',
    buildingLandTitle: 'Building land',
    locationTitle: 'Location',
    servicesTitle: 'Services',
    labelsAndCertificationsTitle: 'Labels and Certifications',
    equipementPresent: 'Equipment present',
    programs: 'Program',
    loyer_an_m2: 'Rent without taxes and without charges per m2/year',
    networks: {
      resetCaption: 'reset',
      commercialText1: 'Displaying your ad posts on ',
      commercialText1Bis: 'is not activated.',
      commercialText2: 'Did you know that you can also subscribe, in addition to this distribution, to the generation of your posts thanks to our Artificial Intelligence?',
      commercialText3: 'Broadcast on ',
      commercialText3Bis: 'are you interested in automatic AI post editing?',
      videoTitre: 'Video',
      videoTexte: 'You can enter a video URL to illustrate your ad post instead of the photos associated with your ad. Please make sure that it is a video URL and not that of a player such as Youtube or Dailymotion which would not be taken into account by social networks.',
      videoUrlError: 'The video URL is not valid',
      videoButtonClap: 'Copy Video Flow URL',
      videoButtonGotoClap: 'You can also generate a video with <strong>Video Flow</strong>',
      videoEditoTitre: '<strong>Or your video link</strong> <span style="font-size: 0.8em">(for Facebook, Instagram, and LinkedIn only)</span>',
      videoEditoHelp: 'The link you insert here must be a link to a file hosted by you. Do not enter YouTube, Vimeo, or other URLs that are playback links. These will not be accepted by social networks.',
      instagram: {
        asideTitle: 'POST INSTAGRAM',
        asideText: 'To save you time, Ubiflow allows you to create personalized content using Artificial Intelligence, based on your ad data. This feature is available with our dedicated offer',
        asideInfoTitle: 'INSTAGRAM INFORMATION',
        asideInfoText1: '1- The broadcast of your post includes your first 10 photos.',
        titleTextarea: 'MANAGING YOUR POST ON INSTAGRAM',
        textInfoTextarea1: 'You can select multiple suggestions before validating and make your choice. You also have the option to edit the content, add emojis, or enrich it with relevant hashtags.',
        textInfoTextarea2: 'If needed, you can revert to the original suggestion at any time by clicking the "Reset" button.',
        textInfoIA: 'For posts generated thanks to our Artificial Intelligence, modifying one or more of your ad\'s criteria will imply a total or partial update of the post initially generated, as long as the post is not broadcast.',
        titleWarning: 'ATTENTION',
        textWarning: 'Once your post has been published, its content can no longer be modified or deleted from your Ubiflow Customer Area.',
        infoNumberCharacters: 'Number of characters allowed:',
        popupNumberCharacters: 'You have exceeded the maximum number of characters.'
      },
      facebook: {
        asideTitle: 'POST FACEBOOK',
        asideText: 'To save you time, Ubiflow allows you to create personalized content using Artificial Intelligence, based on your ad data. This feature is available with our dedicated offer',
        asideInfoTitle: 'FACEBOOK INFORMATION',
        asideInfoText1: '1- Your post includes your first 10 photos.',
        titleTextarea: 'MANAGING YOUR POST ON FACEBOOK',
        textInfoTextarea1: 'You can select multiple suggestions before validating and make your choice. You also have the option to edit the content, add emojis, or enrich it with relevant hashtags.',
        textInfoTextarea2: 'If needed, you can revert to the original suggestion at any time by clicking the "Reset" button.',
        textInfoIA: 'For posts generated thanks to our Artificial Intelligence, modifying one or more of your ad\'s criteria will imply a total or partial update of the post initially generated, as long as the post is not broadcast.',
        titleWarning: 'ATTENTION',
        textWarning: 'Once your post has been published, its content cannot be modified or deleted from your Ubiflow Customer Area.'
      },
      google: {
        asideTitle: 'POST GOOGLE BUSINESS PROFIL',
        asideText: 'To save you time, Ubiflow allows you to create personalized content using Artificial Intelligence, based on your ad data. This feature is available with our dedicated offer.',
        titleTextarea: 'MANAGE YOUR POST ON GOOGLE BUSINESS PROFILE',
        asideInfoTitle: 'GOOGLE BUSINESS PROFILE INFORMATION',
        asideInfoText1: '1- Your post includes 1 photo.',
        textInfoTextarea1: 'You can select multiple suggestions before validating and make your choice. You also have the option to edit the content, add emojis, or enrich it with relevant hashtags.',
        textInfoTextarea2: 'If needed, you can revert to the original suggestion at any time by clicking the "Reset" button.',
        textInfoIA: 'For posts generated thanks to our Artificial Intelligence, modifying one or more of your ad\'s criteria will imply a total or partial update of the post initially generated, as long as the post is not broadcast.',
        titleWarning: 'ATTENTION',
        textWarning: 'Once your post has been published, its content cannot be modified or deleted from your Ubiflow Customer Area.'
      },
      linkedin: {
        asideTitle: 'POST LINKEDIN',
        asideText: 'To save you time, Ubiflow allows you to create personalized content using Artificial Intelligence, based on your ad data. This feature is available with our dedicated offer',
        asideInfoTitle: 'LINKEDIN INFORMATION',
        asideInfoText1: '1- The distribution of your post includes your first 10 photos.',
        titleTextarea: 'MANAGING YOUR POST ON LINKEDIN',
        textInfoTextarea1: 'You can select multiple suggestions before validating and make your choice. You also have the option to edit the content, add emojis, or enrich it with relevant hashtags.',
        textInfoTextarea2: 'If needed, you can revert to the original suggestion at any time by clicking the "Reset" button.',
        textInfoIA: 'For posts generated thanks to our Artificial Intelligence, modifying one or more criteria of your ad will imply a total or partial update of the initially generated post and this as long as the post is not broadcast.',
        titleWarning: 'ATTENTION',
        textWarning: 'Once your post has been published, its content cannot be modified or deleted from your Ubiflow Customer Area.'
      }
    },
    IA: {
      textSpinnerIA: 'Our artificial intelligence is concocting a great post for you. It won\'t be long...'
    },
    instagramTitle: 'Information to be diffused on Instagram',
    immoAncien: 'Old real estate',
    newPrograms: 'New programs',
    postType: 'Type of classified ad',
    facebook: {
      asideTitle: 'Information to publish on your Facebook page',
      asideText: 'Edit from this tab your post as you want it to appear on your Facebook page. ' +
          '<br><br> Ubiflow offers you an automatically generated post based on your ad data.' +
          '<br> You can modify it before its publication.',
      notActivated: 'The diffusion of your ads as Facebook posts is not enabled. To enable this functionality, contact us on 02 99 83 05 36.',
      alreadyBroadcasted: 'Your ad has already been broadcast on your Facebook page. Its content can no longer be modified.',
      generate: 'Regenerate'
    },
    clap: {
      toKnowTitle: 'To know',
      toKnowText: 'By clicking on "Generate my video", the distribution of your post on social networks is automatic. Your video is delivered to you in the form of a URL that you can use as you wish on other media.',
      attentionTitle: 'Attention',
      attentionText: 'Please ensure that your ad contains at least 5 images to ensure that your video renders well.',
      disabledText: 'The video generation product is not activated. For this, contact us at 02 99 83 05 36.',
      informationTitle: 'Information about your videos',
      forfaitClapTitle: 'Monthly fee',
      forfaitClap: '{{ quotaMax }} video',
      monitoringClapTitle: 'Number of videos consumed',
      monitoringClapTooltip: 'The number of cumulative videos corresponds to your monthly plan + the videos not used in previous months',
      monitoringClap: '{{ nbClapGeneres }}/{{ nbClapRestants }} cumulative',
      generateClapButton: 'Generate my video',
      checkUrlClapButton: 'Refresh to get the link of my video',
      downloadClapButton: 'Download video',
      patientTextBegin: 'Your video is being created.<br>Please wait a few minutes before clicking the button.',
      patientTextEnd: 'If you don\'t want to wait, you can also continue browsing your Ubiflow customer area and come back in a few minutes.',
      msgClapInProgress: 'Video generation in progress',
      msgClapEnded: 'Video generation complete !',
      msgClapLaunch: 'Video generation launch'
    },
    socialNetworks: {
      dialogPagesSelection: 'Please select the Facebook page on which you want to publish your posts',
      messageFacebookAutologin: 'Log in again with your pro account to renew the publication rights of the application',
      titleFacebookPages: 'Pages authorized for posting',
      facebookDeconnexion: 'Log out of Facebook',
      googleDeconnexion: 'Sign out of Google',
      dialogLocationsSelection: 'Please select your Google property where you would like to post your publications.',
      dialogOrganizationsSelection: 'Please select your Linkedin organization on which you wish to distribute your publications',
      newPost: {
        introText: 'You are about to create new content to publish on your social networks. To do this, first choose the type of post from those offered to you and follow the instructions.',
        createPostLabel: 'You want to create a post',
        selectPostType: 'Choose the type of post',
        fromAd: 'From an ad',
        fromSoldProperty: 'From a sold property',
        editorial: 'Editorial',
        fromPostTemplate: 'From an editorial post template',
        selectRelatedAd: 'Select the ad concerned',
        title: 'Title',
        reference: 'Reference',
        price: 'Price',
        alreadyPosted: 'This ad is already posted on a social network',
        cancel: 'Cancel',
        editPost: 'Edit post',
        validateAndContinue: 'Validate and continue'
      }
    }
  },
  portals: {
    broadcast: {
      quotaProgram: 'Programs',
      quotaLot: 'Lots',
      noAdSelected: 'No ad selected',
      selectedAds: 'ad selected',
      selectedAds_plural: 'ads selected',
      disableDiffusion: 'Disable diffusion',
      diffuseAds: 'Diffuse these ads',
      quota: 'Quota',
      quotaUnlimited: 'Unlimited',
      lastDiffusion: 'Last diffusion',
      lastDiffusionUnknown: 'Unknown',
      selectedAdsPortal: 'Ad(s) selected',
      tooltipSelectedAdsPortals: 'Total of selected ads served and not served.',
      remainingMessageQuota: 'You have only {{ number }} ads left before reaching your quota',
      reachedAdsLimitQuotas: 'Please note, you have reached your quota, you can no longer select ads.',
      overMessageQuota: 'Please note you have selected more ads than the authorized quota.',
      adsSelection: 'Ads selection',
      adsSelectionText: 'Check the ads you want to diffuse on the portal',
      backProgram: 'Go back to program',
      columnSent: 'Diffused',
      columnSelected: 'Selected',
      columnPicture: 'Picture',
      columnReference: 'Reference',
      columnCity: 'City',
      columnPrice: 'Price',
      columnActions: 'Actions',
      priceContactUs: 'Consult us',
      confirmSelectionDeactivation: 'Are you sure you want to deactivate your ad selection ?',
      confirmSelectionDeactivationTitle: 'Disable broadcast',
      deactivated: 'Disable',
      confirmSelectionDiffusion: 'Are you sure you want to show the selected ads ?',
      confirmSelectionDiffusionTitle: 'Show these ads',
      broadcast: 'Broadcast',
      messageSuccessDeactivation: 'Your deactivation request has been taken into account.',
      messageSuccessDiffusion: 'Your request to broadcast ads has been taken into account.'
    },
    list: {
      diffuseMyAds: 'Diffuse my ads',
      showAllPortals: 'Show all portals',
      returnToDiffusions: 'Return to diffusions',
      activationToPaidPortalTitle: 'Activation of the diffusion to {{ portal }}',
      activationToPaidPortalText: 'This is a paid subscription.' +
          '<br/><br/>Please contact the portal to subscribe, specifying that ' +
          'you are also an Ubiflow client for the diffusion of your ads.' +
          '<br/><br/>Once your subscription validated, Ubiflow will receive the technical information and ' +
          'will configure the diffusion to the portal.' +
          '<br/><br/>Here the commercial contact of the portal : {{ email }}<br/>',
      activationResultTitle: 'Result of the diffusion activation',
      activateUbiflowPackageTitle: 'Activate Ubiflow package',
      activateUbiflowPackageText: 'You are about to activate the diffusion of your ads on the the whole' +
          'Ubiflow visibility package, do you want to validate this activation ?',
      deactivateDiffusionTitle: 'Deactivation of the diffusion',
      deactivateDiffusionText: 'Ara you sure that you want to deactivate the diffusion to this portal ?',
      deactivateDiffusionConfirmation: 'The diffusion has been deactivated.',
      pushToTopOfListTitle: 'Push to top of list of ads',
      activationResultUbiflowPackageTitle: 'Result of package activation',
      activationResultUbiflowPackageAdded: 'Here are the diffusions added to your list of portals',
      activationResultUbiflowPackageRemoved: 'Diffusions to the following portals has been recently deactivated from our portal',
      activationResultUbiflowPackageMessage: 'Ubiflow package evolves and adds new portals continuously. ' +
          'On each notification of new portal added, click aqain on the button ' +
          '´Activate Ubiflow package´ in order to diffuse more broadly.',
      impossibleToActiveModalTitle: 'Activation of the diffusion to the portal : ',
      impossibleToActiveModalText: 'Please contact the portal directly to setup your diffusion.\n' +
          "Here the contact information of the portal's commercial team:",
      mail: 'Email',
      tel: 'Phone',
      confirm: 'Confirm',
      cancel: 'Cancel',
      close: 'Close',
      result: 'Result',
      pushToTopOfList: 'Push to top of list',
      exportResults: 'Export results',
      export: 'Export',
      forSelection: 'For the selection',
      results: 'Results',
      columnActivate: 'Activated',
      columnLogo: 'Logo',
      columnPortal: 'Portal',
      columnAds: 'Ads',
      columnLastDiffusion: 'Last diffusion',
      columnSelectAds: 'Select my ads',
      columnActions: 'Actions',
      columnDiffused: 'Diffused',
      columnPicture: 'Picture',
      columnReference: 'Reference',
      columnCity: 'City',
      columnPrice: 'Price',
      columnEditDiffusion: 'Manage my diffusion',
      columnMyPortal: 'My portal',
      columnCategory: 'Category',
      columnSelectionType: 'Selection type',
      columnContacts: 'Contacts',
      columnProspects: 'Prospects',
      columnPublication: 'Sent on',
      actionReport: 'Diffusion report',
      actionSuspend: 'Suspend the diffusion',
      actionActivate: 'Activate the diffusion',
      buttonAds: 'Ads',
      buttonActivate: 'Activate',
      goBackToDiffusionList: 'Go back to diffusions list',
      deactivateDiffusion: 'Deactivate the diffusion',
      activateDiffusion: 'Activate the diffusion',
      portalSelection: 'Selection of the portals on which to diffuse the ad',
      portalSelectionActivateDiffusionTitle: 'Activate the diffusion for this selection of portals',
      portalSelectionActivateDiffusionText: 'Confirm the selection ?',
      portalSelectionDeactivateDiffusionTitle: 'Deactivate the diffusion for this selection of portals',
      portalSelectionDeactivateDiffusionText: 'Deactivate the selection ?',
      portalSelectionDeactivationConfirmationTitle: 'Deactivation of the diffusion',
      portalSelectionDeactivationConfirmationText: 'The diffusion of your ad has been correctly deactivated.',
      dateLastDiffusion: 'Date of last diffusion',
      noDiffused: 'No diffused',
      numberOfSelectedPortals: 'Number of selected portals',
      numberOfSelectedPrograms: 'Number of selected programs',
      filenameExportDiffusions: 'diffusions',
      filenameExportAdsSelection: 'selection_ads',
      filenameExportPortals: 'list_portals',
      dialogPushToTopOfListTitle: 'Push your ads to top of list',
      dialogPushToTopOfListTextSuccess: 'Your ads will be push to the top of list of selected portals that allowed ' +
          'this functionality on the next diffusion.',
      dialogPushToTopOfListTextLimit: 'You can use this functionality only once a week. Thank you.',
      dialogPushToTopOfListButtonConfirm: 'Confirm',
      dialogPushToTopOfListButtonClose: 'Close',
      dialogEditPostQuota: 'Diffusion status edition to',
      dialogEditIdentifiants: 'Changing Editable IDs',
      champObligatoire: 'Required field',
      aucunIdentifiantEditable: 'No editable ID for this portal',
      doNotBroadcast: 'Do not diffuse',
      unlimited: 'Unlimited',
      limitedToXPosts: 'Ads limit',
      contactBroadcasterToEditQuota: 'In order to modify your diffusion status to this portal, please contact it directly.',
      limitedTo: 'Limited to',
      editQuota: 'Edit quota',
      editIdentifiants: 'Modify / Enter identifiers',
      immowebUrlConnexion: 'Immoweb space connection',
      selogerUrlConnexion: 'Allow Ubiflow to broadcast on the Seloger group sites',
      selectedAds: 'Ad selecteds',
      quotaPerso: 'Personal quota',
      statutDIff: 'Diffusion Status',
      chargementDonnees: 'We are loading your data, a little more patience;)',
      validateLotsDiffusionBailleur: 'You are about to broadcast classified ads and/or programs. By checking this box you confirm that all the lots associated with the selected programme(s) are also broadcast. If you do not want it, uncheck the programs concerned then manually select the batches to broadcast from the "View batches" page.',
      nbLotsBroadcasted: 'Number of lots diffused',
      validateLotsDiffusion: 'You are about to diffuse a new program. Would you like all the associated lots to be diffused as well?',
      noDiffusionTitle: 'Diffusion',
      noDiffusionText1: 'This feature is not activated in your subscription',
      noDiffusionText2: 'WHY ACTIVATE THE UBIFLOW DIFFUSION PRODUCT?',
      noDiffusionText3: 'Doing your diffusion with Ubiflow, give you the possibility to <strong>personalize, enrich, measure and ' +
          'send</strong> your ads on web media with even more relevance. <br><br>' +
          'Whether you manage your ads from a third-party tool (software, website, CRM), or directly ' +
          'in our customer space, ensure the diffusion of your ads in complete autonomy.',
      noDiffusionText4: 'TIME SAVING',
      noDiffusionText5: 'Send your ads everywhere on the various portals in <strong>1 clic.</strong> From only 1 ' +
          'place, your Customer Space ! Forget the multiple accounts you have to log into and the difficulty of using ' +
          'each of them. <strong>A significant time saving!</strong>',
      noDiffusionText6: 'PERSONALIZATION OF YOUR DIFFUSION',
      noDiffusionText7: 'Manage the distribution of your ads in a grouped or personalized way! <br>' +
          'An excellent practice for aiming the <strong>right audience</strong>, on the right medium at the right time ' +
          'depending on your ad inventory.',
      noDiffusionText8: 'MONITOR YOUR PRESENCE ON PORTALS',
      noDiffusionText9: '<strong>Follow the distribution of your ads</strong> thanks to our distribution and presence reports. ' +
          'We quickly identify the blocking points and the reasons in order to intervene as soon as possible. ' +
          "Don't worry about anything! Our team contacts the portals concerned.",
      noDiffusionText10: 'CALCULATE YOUR ROI AND MANAGE YOUR BUDGET',
      noDiffusionText11: 'Our diffusion tool coupled with our contact management solution ',
      noDiffusionText12: ' allows you to identify the portals where your ads are <strong>visited the most</strong> and ' +
          '<strong>which generate the most contact. Optimize your diffusion costs!</strong>',
      noDiffusionText13: '24 options enrich our diffusion product, most of which are included by default : ' +
          'selective diffusion, personalization of the contact details indicated on your ads, push to top of ' +
          'the list, edition tool, multi-transmitter, …',
      reconciliationRequests: 'Reconciliation requests',
      TextReconciliation: 'These are requests made by Internet users on a portal but which do not refer to a particular advertisement. An email notification is sent to you in parallel for the sites allowing it. These contacts are not counted in the number of contacts generated in total.',
      selogerMessaqeAuthorisationOk: '<div>You have authorized Ubiflow to broadcast on the Seloger group sites.</div>\n<div>Our customer relations has been notified, thank you.</div>',
      selogerMessaqeAuthorisationKo: 'Loading error on this page'
    },
    report: {
      globalTitle: 'General statisticsMeta',
      title: 'Statistics of the diffusion  on the portal',
      quota: 'Quota',
      quotaAds: 'ads',
      quotaUnlimited: 'Unlimited',
      selectedAds: 'ads selected',
      selectionMode: 'Ads selection mode',
      lastDiffusion: 'Last diffusion',
      adsDiffused: 'ads diffused',
      filter: "'Filter ads by reference...",
      selected: 'Selected',
      diffused: 'Diffused',
      published: 'Published',
      exportResults: 'Export results',
      exportResultsWithoutContact: 'Export contactless ads',
      columnStatus: 'Status',
      columnAd: 'Ad',
      columnReference: 'Reference',
      columnDateCreation: 'Creation date',
      columnDateModification: 'Modification date',
      columnPictures: 'Nb. picture',
      columnDateDiffused: 'Diffusion date',
      columnLogo: 'Logo',
      columnPortal: 'Portal',
      columnDateDiffusion: 'Diffusion date',
      columnAdsDiffused: 'Ads diffused',
      statusError: 'Error',
      statusPublished: 'Published',
      statusDiffused: 'Diffused',
      statusIgnored: 'Ignored',
      convertDateBeginning: 'The {{ date }}',
      lastUpdateAds: 'Last modification of the ads',
      activePortals: 'Active portals',
      globalAdsDiffused: 'Ads diffused',
      detailedReportsPortalByPortal: 'Detailed reports, portal by portal',
      noMessage: 'No message',
      filenameExportDiffusion: 'export_report_diffusion'
    }
  },
  users: {
    edit: 'Edit',
    addUser: 'Add an user',
    role: 'Role',
    rolePlaceholder: 'Select a role...',
    lastname: 'Lastname',
    firstname: 'Firstname',
    email: 'Email',
    phone: 'Phone',
    mobile: 'Mobile',
    address: 'Address',
    postalCode: 'Postal code',
    city: 'City',
    country: 'Country',
    price: 'User prices',
    placeholderPrice: 'Indicate the url to the agency prices',
    cancel: 'Cancel',
    confirm: 'Confirm',
    createNewUser: 'Create a new user',
    editUser: 'Edit user',
    messageCreate: 'The user has been successfully created',
    messageCreateAccess: 'Your request has been received ' +
        'Our team will contact you as soon as possible to jointly define the different access modalities.',
    messageUpdate: 'The user has just been deleted',
    messageDelete: "L'utilisateur vient d'être supprimé",
    messageError: 'An error occurred',
    forSelection: 'For the selection',
    export: 'Export',
    exportAll: 'Export all',
    listMode: 'List mode',
    vignetteMode: 'Grid mode',
    enabled: 'Enabled',
    disabled: 'Disabled',
    actionsOnThisUser: 'Actions on this users',
    logIn: 'Log in',
    allUsers: 'All users',
    activeUsers: 'Active users',
    inactiveUsers: 'Inactive users',
    confirmationMessage: 'You will be redirected to the customer space of a collaborator linked to your account.',
    caution: 'Caution',
    mailSended: 'Account creation instructions has been sent by email to the user.',
    createAccess: 'Do you want to create a Customer Space access to this new contact?',
    mainAccount: 'main account',
    contact: 'Contact',
    admin: 'Administrator',
    user: 'User'
  },
  profile: {
    save: 'Save',
    cancel: 'Cancel',
    myPersonalInformation: 'My personal information',
    lastname: 'Lastname',
    firstname: 'Firstname',
    email: 'Email',
    phone: 'Phone',
    agencyInformation: 'Agency information',
    corporateName: 'Corporate name',
    companyName: 'Company name',
    address: 'Address',
    postalCode: 'Postal code',
    city: 'City',
    country: 'Country',
    fax: 'Fax',
    website: 'Website',
    price: 'User prices',
    placeholderPrice: 'Indicate the url to the agency prices',
    logo: 'Logo',
    uploadTip: 'Jpg/jpeg/png files with a size of less than 2Mo',
    activateAdsToTopFunctionality: 'Activate the manual management of the "push to the top" functionality for your ads on compatibles portals.',
    messageSuccess: 'Settings has been updated',
    messageSuccessAgency: 'Agency settings has been updated',
    messageError: 'An error occurred',
    saveFilters: 'Keep my search filters after I log out',
    Configurations: 'Other configurations',
    saveFiltersTitle: 'Configuring search on my Ubiflow Customer Area',
    activateAdsToTopFunctionalityTitle: 'Configuring top of list feeds',
    soldProductMaskColorTitle: 'Configuring the color of the banners sold'
  },
  exports: {
    description: 'Your files will be available here for two weeks from the date of export.',
    removeTitle: 'Delete your file',
    removeText: 'Are you sure that you want to delete your file?',
    removeSuccess: 'Your file has been deleted successfully.',
    multipleRemoveSuccess: 'Your files have been deleted successfully.'
  },
  general: {
    yes: 'Yes',
    no: 'No',
    month: 'mes',
    year: 'año',
    week: 'week',
    exitConfirmation: 'Are sure that you want to leave ?',
    ubiflowWebsite: 'Ubiflow.net',
    calendar: {
      socialManagment: 'Adopt a Social Media Strategy',
      planningSubtitle: 'Subscribe to the Social Manager + offer to access a complete tool for managing your presence on social networks and optimizing your local referencing:',
      planning: 'Planning management',
      changeTheSchedule: 'Change the schedule',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      lastThreeMonths: 'Last 3 months',
      lastSixMonths: 'Last 6 months',
      lastTwelveMonths: 'Last 12 months',
      slogan1: 'Select publication days and times',
      slogan2: 'Integrate an effective Social Media strategy',
      slogan3: 'Overcome a repetitive task',
      slogan4: 'Reduce your time planning posts',
      slogan5: 'Ensure a regular presence on your social networks',
      slogan6: 'Review management and automated responses thanks to AI\n',
      slogan7: 'Management of questions/answers posted on Google',
      slogan8: 'Access to statistical data collected on Google',
      planningDate: 'Publication date',
      spreadOn: 'broadcast on',
      scheduled: 'Plan',
      publishNow: 'Publish now',
      edit: 'Edit',
      delete: 'Delete',
      postNoPlanned: 'Unplanned post',
      postPublished: 'Post published',
      postPlanned: 'Scheduled post',
      postAlreadyPlanned: 'Post already published',
      acceptedPost: 'Accepted',
      refusedPost: 'Denied',
      planningPost: 'Planning',
      publishingPost: 'Publishing',
      areYouSureYouWantToPublishYourPost: 'Are you sure you want to publish your post?',
      areYouSureYouWantToPlanYourPost: 'Are you sure you want to plan your post?',
      thePostWasPlanned: 'The post was planned.',
      thePostWasPublished: 'The post was published.',
      ThePlanningWasUnsuccessful: 'The planning was unsuccessful.',
      ThePublicationWasUnsuccessful: 'The publication was unsuccessful.',
      TheCurrentScheduleHasBeenCanceled: 'The current schedule has been canceled.',
      TheCurrentPublicationHasBeenCanceled: 'The current publication has been canceled.',
      deletionHasBeenUndone: 'Deletion has been undone.',
      deletionHasBeenCompleted: 'Deletion has been completed.',
      theChangeHasBeenMade: 'The change has been made.',
      theChangeHasBeenUndone: 'The change has been undone.',
      areYouSureYouWantToDeleteYourSchedule: 'are you sure you want to delete your schedule ?',
      areYouSureYouWantToDeleteYoursScheduleSelected: 'Are you sure you want to delete your selected schedules {{refsUniquesSelection}} ?',
      areYouSureYouWantToChangeYourSchedule: 'Are you sure you want to change your schedule?',
      warningSheduledBefore: 'Your schedule cannot be executed because it is before today\'s date.',
      deletionFailed: 'Deletion failed.',
      deletionPost: 'Deletion post',
      Amendment: 'Amendment',
      deleteSchedule: 'Delete schedule',
      mailSubjectSocialManagmentPlus: 'New request for information on the Social Manager + offer from the Customer Area',
      emailContentSocialManagmentPlus: 'Hello, A new request for information has been made from the Customer Area for the Social Manager + package' +
            ' by advertiser {{advertiser}} ({{companyName}}) . You can contact him again ' +
            ' via {{email}} or at {{phoneNumber}}' +
            ' THANKS. Good day.',
      emailSendSuccess: 'Your email was sent successfully.',
      loaderMessageCalendar: 'Patience ! Your data is loading, it may take a few seconds.',
      featureForbidden: 'Feature not available'
    },
    sort: {
      date: 'Date',
      decreaseDate: 'Decreasing date',
      increaseDate: 'Increasing date',
      reference: 'Reference',
      title: 'Title',
      name: 'name',
      lastDiffusion: 'Date of last diffusion',
      datePublication: 'Date of publication',
      ads: 'Ads',
      contacts: 'Contacts',
      dateCreation: 'Date of creation',
      contactEmail: 'Contacts email',
      contactTel: 'Contacts phone',
      contactName: 'Contact name',
      callDurationDecrease: 'Decreasing call duration',
      callDurationIncrease: 'Increasing call duration',
      callNumber: 'N° phone',
      portalName: 'Portal name',
      creationDate: 'Creation date'
    },
    selection: {
      forSelection: 'For the selection',
      exportAll: 'Export all',
      export: 'Export',
      activateDeactivate: 'Activate/Deactivate',
      changeContact: 'Edit contact',
      activeAds: 'Active ads',
      inactiveAds: 'Inactive ads',
      download: 'Download',
      remove: 'Delete',
      validate: 'Valid'
    },
    filters: {
      allAds: 'All ads',
      allPrograms: 'All programs',
      allLots: 'All lots',
      activeAds: 'activated ads',
      inactiveOrDraftAds: 'inactivated or draft ads',
      withoutPictures: 'ads with no pictures',
      diffusedAds: 'diffused ads',
      noDiffusedAds: 'No diffused ads',
      modelAds: 'Model ads',
      stockSelection: 'Selection of the stock',
      stockSelectionPlaceholder: 'Select a stock',
      brand: 'Brand',
      brandPlaceholder: 'Select a brand',
      model: 'Model',
      models: 'Models',
      modelPlaceholder: 'Select a model',
      openSearch: 'Search by city, title, reference',
      openSearchPlaceholder: 'Search',
      offerType: 'Offer type',
      offerTypePlaceholder: 'Select a type',
      programType: 'Program type',
      programTypeLand: 'Land',
      programTypeLandHouse: 'Land + house program',
      propertyType: 'Property type',
      propertyTypeVo: 'Vehicle type',
      mandateType: 'Mandate type',
      mandateTypeAll: 'All',
      mandateTypeSimple: 'Simple',
      mandateTypeExclusive: 'Exclusive',
      mandateTypeSemiExclusive: 'Semi-exclusive',
      date: 'Search by date',
      dateCreation: 'Date of creation',
      dateDiffusion: 'Date of diffusion',
      datePublication: 'Date of publication',
      dateCreationStart: 'From...',
      dateCreationEnd: 'to...',
      surface: 'Surface : between {{ surfaceGt }}m² and {{ surfaceLt }}m²',
      vehicleYear: 'Year',
      priceMin: 'Min price',
      priceMax: 'Max price',
      tooltipContactList: 'So that all your contacts appear in the list below, make sure you have entered their first and last name in the contact book.',
      title: 'Search by title',
      titleReference: 'Search by title, reference',
      titleReferenceCity: 'Search by title, reference, city',
      portalName: 'Search by portal name',
      titlePlaceholder: 'Search...',
      portalCategory: 'Portal category',
      portalCategoryPlaceholder: 'All categories',
      businessModel: 'Business model',
      businessModelFree: 'Free',
      businessModelPaid: 'Paid',
      quota: 'Ads quota',
      quotaWith: 'With quota',
      quotaWithout: 'Without quota',
      allPortals: 'All portals',
      activePortals: 'Active portals',
      inactivePortals: 'Inactive portals',
      onlySelectedPortals: 'Only selected portals',
      onlyNoSelectedPortals: 'Only unselected portals',
      adReference: 'Ad reference',
      adReferencePlaceholder: 'Search...',
      integratedAds: 'Ads integrated',
      warningAds: 'Warning',
      errorAds: 'Ads rejected',
      noPictureAds: 'Ads without pictures',
      adsWithContacts: 'Ads with contacts',
      adsWithoutContacts: 'Ads without contact',
      onlyActiveAds: 'Only active ads',
      freePortals: 'Free portals',
      paidPortals: 'Paid portals',
      portalsWithoutContact: 'Portals without contact',
      portalsWithContacts: 'Portals with contacts',
      allContacts: 'All contacts',
      name: 'Search by name',
      referenceContactEmail: 'Search by reference, contact, or email',
      portalContactEmail: 'Search by portal name, contact or email',
      phoneNumber: 'Search by phone number',
      callStatus: 'Call status',
      callAnswered: 'Call answered',
      callMissed: 'Call missed',
      all: 'All',
      typeLandHouse: 'Land + house program',
      resetFilters: 'Reset filters',
      deletedPosts: 'Listings removed',
      socialNetworks: 'Social networks',
      soldPosts: 'Property sold',
      marchandVo: 'Merchant vo',
      marchandVoPlaceholder: 'Choose a used vehicle dealer',
      energie: 'Energy',
      energiePlaceholder: 'Choose an energy',
      kilometrageMin: 'Minimum mileage',
      kilometrageMax: 'Max mileage',
      achatvo: 'Purchase',
      achatvoPlaceholder: '(Lot or individually)',
      achatLot: 'Batch',
      achatUnite: 'Individually',
      annoncesValides: 'Validated ads',
      annoncesNonValides: 'Unvalidated ads',
      negociateur: 'Search by agent',
      negociateurPlaceholder: 'Search...'
    }
  },
  planning: {
    calendar: 'calendar',
    backToCalendar: 'Back to calendar',
    title: 'Planning management',
    day: 'Day',
    today: 'today',
    week: 'Week',
    month: 'Month',
    jour4: '4 Days',
    beContacted: 'Interested in this product? Be contacted by a sales advisor.',
    searchByTitle: 'Search by title, reference',
    searchPlaceholder: 'Search',
    typePost: 'Type of content',
    choiceTypePost: 'Choose by content type',
    all: 'All posts',
    instagram: 'Instagram',
    facebook: 'Facebook',
    gmb: 'Google Business Profile',
    linkedin: 'Linkedin',
    dialogMessage: 'You want information about our Social Manager + product. Our team will contact you as soon as possible.',
    postsAds: 'Posts of advertisements',
    postsBv: 'Sold properties',
    postsEdito: 'Editorial posts',
    searchByMonth: 'Search by month',
    selectedMonth: 'Select a month',
    postsList: 'List of posts',
    forSelection: 'For selection ({{ selectedNumber }}):',
    resultsOfTheDate: 'Résultat(s) pour la date de',
    titleAds: 'Ad title',
    pictures: 'Photos',
    publishOn: 'Published on',
    date: 'Date',
    status: 'Status'
  },
  socialPosts: {
    list: {
      postAnnonces: 'Ad posts',
      biensVendus: 'Sold goods posts',
      postsEditoriaux: 'Editorial posts',
      publishOn: 'Published on',
      publishedOn: 'Published on',
      actions: 'Actions',
      noSubscription: 'You have not subscribed to the "social networks and local presence" offer. <br>\n' +
        'For more information and to be contacted by a sales representative, click on the button below.'
    },
    planification: {
      title: 'Schedule your posts',
      instruction: 'Choose when to publish your content on each selected social network.',
      selectDateTime: 'Select date and time',
      publishNow: 'Or publish now',
      alreadyPublishedFacebook: 'Your post has already been published on Facebook',
      alreadyPublishedInstagram: 'Your post has already been published on Instagram',
      alreadyPublishedGoogle: 'Your post has already been published on Google',
      alreadyPublishedLinkedin: 'Your post has already been published on LinkedIn',
      apply: 'Apply my publishing choices'
    },
    scheduledAt: 'Scheduled on',
    sentAt: 'Sent on',
    models: {
      title: 'My post templates library',
      header: 'To create a new post from a template, you can select a template from the list below by clicking on "Use".\n' +
        '<br><br>' +
        'From the post editing form, you will be able to modify its content, text, and media as well as manage the media selection.',
      saveModel: 'Save the template',
      cantEdit: 'This template comes from your network head, you cannot edit it',
      cantDelete: 'This template comes from your network head, you cannot delete it',
      backToPosts: 'Back to my posts',
      createModel: 'Create a template',
      deleteModelTitle: 'Delete template',
      deleteModelConfirm: 'Are you sure you want to delete this template?',
      cancel: 'Cancel',
      delete: 'Delete',
      myModels: 'My templates',
      networkModels: 'Network templates',
      create: 'Create an editorial post template',
      edit: 'Edit template',
      use: 'Use template',
      modelSummary: 'Model summary',
      for: 'For',
      actions: 'Actions'
    },
    create: {
      core: {
        missingRequiredFields: 'You have not filled in the required fields.',
        putOnDraft: 'Save as draft',
        missingNetworkSelection: 'You have not filled in all the required fields or you have not selected any social network for distribution.',
        publish: 'Publish',
        cancel: 'Cancel',
        returnToList: 'Return to list',
        modalDeletePlanifBrouillons: 'You are about to change this post to draft. When you want to publish this post on social networks of your choice, you will need to provide a new scheduling date.'
      },
      deletePlanifBrouillons: {
        message: 'You are about to change this post to draft. When you want to publish this post on social networks of your choice, you will need to provide a new scheduling date.',
        confirm: 'I confirm the change to draft',
        cancel: 'Cancel'
      },
      validator: {
        fieldsRequired: 'You have not filled in the required fields.',
        fieldsRequiredComplete: 'You must complete all mandatory fields: Title, content, media and choose at least one social network.'
      },
      modalAI: {
        objectTitle: 'Specify the purpose of the post in a few words: "Open house", "Recruitment", ...',
        objectSubtitle: 'The more precise you are by bringing context elements, the more your message will be written with a high level of quality and personalization.\n' +
          '        <br>Note: Only one generation through our AI is possible per media and per post.',
        cancel: 'Cancel',
        generatePost: 'Generate my post'
      },
      confirmStop: {
        title: 'Cancel post customization',
        text: 'If you confirm, the customization of your post for this social network will be lost. Are you sure you want to continue?'
      },
      publishNow: {
        title: 'Publish now',
        text: 'Are you sure you want to publish your post now on the selected social networks?',
        confirm: 'Yes, I want to publish now',
        cancel: 'Return to the previous step'
      },
      confirmStopCustom: {
        title: 'Cancel post customization',
        text: 'If you confirm, the customization of your post for this social network will be lost. Are you sure you want to continue?'
      },
      initial: {
        title: 'Initial publication',
        subtitle: 'This initial content will be used for all social networks selected in the right part of this screen.\n' +
          '    All changes made here will be automatically applied to non-customized publications.',
        libelle: 'Post title *',
        tooltipLibelle: 'This title will not be distributed on social networks and will only be visible to you.',
        textContent: 'Post text content *',
        textContentInfo: 'You can freely write your post from the field at your disposal or take advantage of our\n' +
          '                      automatic post generation tool\n' +
          '                      thanks to our <b>artificial intelligence</b> solution. For this, nothing simpler: click on\n' +
          '                      the button below and follow the instructions.',
        linkToYourVideo: 'Link to your video'
      },
      alreadyPublished: 'This post has already been published: <br> deletion or modification impossible.',
      customizePost: 'Customize the post',
      selectTypePost: 'Select a post type *',
      chooseTypeOfPost: 'Choose the type of post',
      actionButton: 'Action button',
      typeOfActionButton: 'Choose the type of action button',
      urlActionButton: 'Link associated with your post',
      learnMore: 'Learn more',
      tooltipGoogleUTM: 'If you have Google Analytics, you can enter the UTM campaign index here.',
      postWithPictures: 'Post with picture(s)',
      typeNews: 'News',
      redactWithAi: 'Write your post using AI',
      promoCode: 'Promo code',
      promoCodeDetail: 'If you want to offer a promotional code that can be used online or at the point of sale.',
      offerLink: 'Offer link',
      offerLinkDetail: 'Specify the URL of the page that allows you to take advantage of the online offer.',
      medias: 'Media',
      IAButtonDisabled: 'Please fill in the title before using AI',
      saveDraft: 'Save as draft',
      publish: 'Publish'
    }
  },
  socialReviews: {
    backToReviews: 'Back to customer reviews',
    suggestedReviews: 'Suggested reviews',
    title: 'Customer reviews',
    description: 'From this tab, you will find all customer reviews from your Google and Facebook pages.',
    search: {
      openSearch: 'Free search',
      media: 'Media',
      rate: 'Rating',
      creationDate: 'Creation date',
      detectionDate: 'Detection date',
      review: 'Review',
      allReview: 'All',
      new: 'New',
      toAnswer: 'To answer',
      answered: 'Answered',
      deleted: 'Deleted'
    },
    modal: {
      respondToReview: 'Respond to review',
      respondToIA: 'Respond with AI',
      messageModal: 'You have responded to this review'
    },
    table: {
      messageAnswer: 'You have not responded to this review'
    },
    stats: {
      reviewCount: 'Number of reviews',
      unansweredReviewsCount: 'Reviews awaiting response',
      averageRate: 'Average rating'
    },
    autoAnswers: {
      title: 'Automatic responses to reviews without text',
      subtitle: 'You have the option to write responses that will automatically be sent to reviews that do not contain text.',
      rate: 'Rating',
      noAutoAnswer: 'You have no automatic response for this rating',
      edit: 'Edit'
    },
    export: {
      fileNameExportReviews: 'customer_reviews_list',
      noticeContent: 'Review content',
      dateOfPublication: 'Publication date',
      dealerName: 'Reviewer name',
      pointOfSaleName: 'Point of sale',
      numberOfStars: 'Number of stars'
    },
    titleSuggestedReviews: 'Customer reviews solicitation email',
    text1SuggestedReviews: 'From this page, you can send an email to request reviews from your customers by writing your own text or using the example already created.',
    text2SuggestedReviews: 'Thanks to the redirection links to your Google and Facebook pages, your customers only need one click to leave a review.',
    sendSelected: 'Send selection',
    enterMail: 'Enter the recipient\'s email'
  },
  contactManager: {
    contactsGenerated: 'Contacts generated',
    allContacts: 'All contacts',
    summaryOfContacts: 'Summary of contacts',
    contactsByPost: 'Contacts by ads',
    contactsByPortal: 'Contacts by portals'
  },
  broadcasts: {
    broadcastLists: 'List of broadcasts',
    broadcastSocialNetworks: 'Social network broadcasts'
  },
  socialNetworks: {
    dialogPagesSelection: 'Please select the Facebook page on which you want to publish your posts',
    messageFacebookAutologin: 'Log in again with your pro account to renew the publication rights of the application',
    titleFacebookPages: 'Pages authorized for posting',
    facebookDeconnexion: 'Log out of Facebook',
    newPost: {
      introText: 'You are about to create new content to publish on your social networks. To do this, first choose the type of post from those offered to you and follow the instructions.',
      createPostLabel: 'You want to create a post',
      selectPostType: 'Choose the type of post',
      fromAd: 'From an ad',
      fromSoldProperty: 'From a sold property',
      editorial: 'Editorial',
      fromPostTemplate: 'From an editorial post template',
      selectRelatedAd: 'Select the ad concerned',
      title: 'Title',
      reference: 'Reference',
      price: 'Price',
      alreadyPosted: 'This ad is already posted on a social network',
      cancel: 'Cancel',
      editPost: 'Edit post',
      validateAndContinue: 'Validate and continue'
    }
  },
  tutoralsVideos: {
    menu: {
      titleMenu: 'Summary',
      linkDashboard: 'Dashboard',
      linkAnnouncementsPage: 'Announcements',
      linkProgramsPage: '  Programs',
      linkBroadcast: 'Broadcast',
      linkContactManager: 'Contact Manager',
      linkSocialManagement: 'Social Manager'
    },
    title: 'Tutorial videos',
    infoButtonGoToBack: 'Return to customer area',
    textButtonGuide: 'Export user guide',
    videos: {
      title1: 'Discover your dashboard',
      description1: 'This first video will allow you to understand your User Space and discover the different elements integrated into your dashboard. Let\'s discover the first tabs together for a first understanding of your environment.',
      title2: 'Master the ad tab',
      description2: 'From our input tool, you can create an ad at any time using the constantly accessible "Create an ad" button in your customer area. In particular, you will be able to add a personalized description and media content.',
      title3: 'The broadcast tab',
      description3: 'From the "Dissemination", tab you can consult and modify your mailing list and also receive a distribution report from the portal and manage the distribution of your ads on a portal.',
      title4: 'Discovery of the Contact Manager tab',
      description4: 'Discover the Contact Manager tab which allows you to manage and centralize your contacts and monitor interactions.',
      title5: 'Creating an ad',
      description5: 'Find out how to successfully create and publish an ad from your Ubiflow user space and simplify sending your ad posts.'
    }
  },
  statisticsMeta: {
    networksStatistics: 'Statistics of your social networks',
    overview: 'Overview',
    publicationReport: 'Publication report',
    discover: 'Discover',
    titleFacebook: 'Statistics for your Facebook page',
    titleInsta: 'Statistics of your Instagram page',
    likedPage: 'Mentions j\'aime de la page ',
    viewsNumber: 'Number of views',
    followersNumber: 'Number of followers ',
    likeNumber: 'Number of likes',
    numberPublication: 'Number of publications',
    allNumberViews: 'Total number of media views ',
    publication: 'Publications ',
    totalInteractions: 'The total number of interactions with your posts',
    reach: 'Total number of unique media views',
    shares: 'Number of shares',
    saves: 'Number of saves of your content',
    comments: 'Number of comments',
    likes: 'Likes on your content',
    accountsEngaged: 'Number of accounts that have interacted with your content',
    pageDailyFollows: 'The number of people who follow your Facebook page ',
    pagePostEngagements: 'The number of interactions with your posts',
    pageTotalActions: 'The number of clicks on your Page\'s contact details',
    postsInsta: 'Intagram posts',
    postsFacebook: 'Facebook posts',
    growingYourInstagramCommunity: 'Growing your Instagram community',
    growingYourFacebookCommunity: 'Growing your Facebook community',
    boxInfosContentFacebook: 'You must have at least 100 likes from your Facebook page to have statisticsMeta available.',
    boxInfosContentInstagram: 'You must have at least 100 followers on your Instagram page to have statisticsMeta available.',
    toolTipsStatsContent: 'These statisticsMeta relate to the overall performance of your page. Filters do not affect this data',
    toolTipsStatsGraphContent: 'Use the filters to highlight the numbers you want to see.',
    seePostDetails: 'See the post details',
    loadingInProgress: 'Loading in progress...',
    nbPeopleWhoSeenPublications: 'Number of people who have seen your posts',
    infoNumberStats: 'The numbers in the "Interactions" section are related to the period shown on the community growth chart.'

  },
  statisticsLinkedin: {
    titleLinkedin: 'Statistics of your Linkedin page',
    discover: 'Discover',
    postsLinkedin: 'Linkedin publications',
    growingYourLinkedinCommunity: 'Growing your Linkedin community',
    numberImpressionTotal: 'Number of total impressions',
    followersNumber: 'Number of followers on the page',
    followersNumberByMonth: 'Number of additional followers per month',
    numberOfReaction: 'Number of reactions',
    numberOfComments: 'Number of comments',
    numberOfShare: 'Number of shares',
    numberCliksOntheLink: 'Number of clicks on link'
  },
  statisticsDBKS: {
    numberEditorial: 'Number of editorial post(s)',
    numberAdsPost: 'Number of ads post(s)',
    numberDraftPost: 'Number of draft post(s)',
    statusOfBroadcasts: 'Status of sharing your information on various media',
    contentOfBroadcasts: 'The local presence solution enables you to broadcast your information on the various associated media (Google maps, Apple maps, Waze...).',
    broadcast: 'Broadcasts',
    inProgress: 'In progress',
    broadCastError: 'Broadcast error',
    total: 'Total',
    other: 'other'
  },
  statistics: {
    linkToStatistics: 'Access your statistics',
    linkToReportByPosts: 'Access your reports by post',
    GrowingYourCommunityOnSocialNetworks: 'Growth of your community on different social networks',
    titleAd: 'Post title',
    publishedAt: 'Published on ',
    top: 'TOP'
  },
  autoOpenDialog: {
    title: 'New Social Manager feature',
    content: 'You can now view the statisticsMeta of your Facebook and Instagram accounts directly from the new "Statistics" section of your Customer Area. ',
    content1: 'To do so, click on the button below, then on the "Facebook login" button on the landing page.',
    content2: 'The social network requires 100 likes from your Facebook page and 100 followers from your Instagram account to enable your statisticsMeta to be reported. If this isn\'t the case, don\'t hesitate to bring your community to life by publishing more posts with our Social Manager solution!',
    titleCancelledButton: 'Cancel',
    titleConfirmButton: 'Access',
    disabledMessage: 'Do not receive this message again'
  },
  autoOpenDialogLinkedin: {
    title: 'New Social Manager feature',
    content: 'You can now view your Linkedin account statistics directly from the "Statistics" section in your Customer Area. ',
    content1: 'To do this, click on the button below, then on the "Linkedin login" button on the landing page.',
    content2: 'Attention! To view LinkedIn statistics from your Customer Area, you must be a Super Administrator or Administrator of the company page',
    titleCancelledButton: 'Cancel',
    titleConfirmButton: 'Access',
    disabledMessage: 'Stop receiving this message'
  },
  autoOpenDialogGoogle: {
    title: 'New Social Manager Feature',
    content: 'You can now check your Google account statistics directly from the "Statistics" section of your Client Area.',
    content1: 'To do this, click on the button below, then on the "Google login" button found on the landing page.',
    content2: 'Warning! To view Google Business Profile statistics from your Client Area, you must be a Super Administrator or an Administrator of the business page.',
    titleCancelledButton: 'Cancel',
    titleConfirmButton: 'Access',
    disabledMessage: 'Do not receive this message anymore'
  },
  KPI: {
    messageErrorLoading: 'An error occurred while loading'
  },
  etablishmentSheet: {
    messageLoadData: 'An error occurred while loading data.',
    messageUploadPhotoError: 'An error occurred while uploading the photos.',
    messageUploadPhotoSuccess: 'Your photos have been successfully saved and will be updated.',
    messageDeletedPhotoError: 'An error has occurred during deletion',
    messageDeletedPhotoSuccess: 'Your photo has been successfully deleted',
    errorPhoto2004: 'The data entered is invalid.',
    errorPhoto2501: 'The POI has too many photos',
    errorPhoto2502: 'POI must have at least one photo',
    errorPhoto2503: 'Unable to obtain photo',
    errorPhoto2504: 'Photo method not supported',
    errorPhoto2505: 'Photo too small',
    errorPhoto2506: 'Photo too large',
    errorPhoto2507: 'Photo has wrong ratio',
    errorPhoto2508: 'Photo weight is invalid',
    errorPhoto2509: 'Photo is duplicated',
    errorPhoto2510: 'Photo is unchangeable',
    errorPhoto2511: 'Deleted photo before uploading new one',
    title: 'Data on your facility record',
    subtitleValidationData: 'Validation data',
    subtitleDataGeneral: 'General data',
    subtitleAdress: 'Address',
    subtitlePhotos: 'Photos',
    subtitleVideos: 'Videos',
    subtitleSchedules: 'Schedules',
    subtitleExceptionalSchedules: 'Exceptional Schedules',
    subtitleWebsites: 'Websites',
    idExternal: 'Id Externe',
    companyName: 'Company name',
    tradeName: 'Trade name',
    longTradeName: 'Long trade name',
    contactName: 'Contact name',
    firstNameOfContact: 'First name of contact',
    phone: 'Telephone',
    phone2: 'Phone 2',
    phone3: 'Phone 3',
    mobile: 'Mobile',
    mail: 'Business email',
    mailAdmin: 'Administrative email',
    statusCompany: 'Business status',
    placeholderStatusCompany: 'Please select status',
    underConstruction: 'Under construction (never opened)',
    temporarilyClosed: 'Temporarily closed',
    siret: 'Siret',
    openingDate: 'Date d\'ouverture',
    mediaStoreGoogle: 'Store codes Medias (Google)',
    validationMobile: 'Validation: Mobile phone number',
    validationMail: 'Validation: Mail address',
    businessAddress: 'Business address',
    businessAddressComplement: 'Complement to business address',
    postalCodeCompany: 'Business postal code',
    cityCompany: 'City of business',
    country: 'Country of business',
    latitude: 'Latitude',
    longitude: 'Longitude',
    geoTitleButton: 'Geolocate address on map',
    addCatchmentArea: 'Add a catchment area',
    infoCatchmentAreaContent1: 'We recommend using catchment areas by PlaceId to improve their accuracy',
    infoCatchmentAreaContent2: 'For this, you can use the ',
    infoCatchmentAreaContent2Suite: 'provided by Google.',
    infoCatchmentAreaContent3: 'The result will be displayed as a tooltip. The first bold line corresponds to the name and the second to the PlaceId',
    days: 'Days',
    date: 'Dates',
    status: 'Status',
    fullHours: '24/24',
    duplicate: 'Duplicate',
    delete: 'Delete',
    addSchedule: 'Add a period',
    actions: 'Actions',
    open: 'Open',
    close: 'Closed',
    save: 'Save form',
    savePictures: 'Save pictures',
    cancel: 'Cancel',
    create: 'Create',
    logo: 'Logo',
    profile: 'Profile',
    cover: 'Cover',
    gallery: 'Gallery',
    minSize: '450x450px minimum',
    maxSize: '5200x5200px maximum',
    weightBetween: 'Between 10Ko and 4Mo',
    maxPhotosGallery: 'Maximum 20 photos',
    chooseFile: 'Choose a file',
    chooseAddDay: 'Add a day',
    chooseSeveralDays: 'Add several days',
    tooltipContentIdExterne: 'Enter the identifier in numbers and/or letters that will be unique to this establishment',
    tooltipContentCompanyName: 'Company name of point of interest',
    tooltipContentNomCommerce: 'Name of the point of interest',
    tooltipContentLongName: 'Long name, used in priority on certain media that allow it (Google...)',
    tooltipContentContactName: 'Point of interest contact name',
    tooltipContentContactFirstname: 'First name of point of interest contact',
    tooltipContentPhone: 'Main telephone number of the point of interest',
    tooltipContentPhone2: 'Telephone n°2 of the point of interest',
    tooltipContentPhone3: 'Telephone n°3 of the point of interest',
    tooltipContentMobile: 'Mobile phone of point of interest',
    tooltipContentMail: 'Public email address sent to portals for publication as "contact"',
    tooltipContentMailAdmin: 'Private email address, used for service management and the administration of listings, particularly in Google My Business',
    tooltipContentStatus: 'Status of the point of interest',
    tooltipContentSIRET: 'SIRET number of the point of interest',
    tooltipContentOpeningDate: 'This is the date of the first opening of your point of sale, it must be in the past or at most 1 year in the future',
    tooltipContentStoreCodeMedias: 'Store codes on media',
    tooltipContentValidationDataMobile: 'Mobile phone number used to validate GBP registration',
    tooltipContentValidationDataMail: 'Email address used to validate GBP registration',
    tooltipContentAdresseCommerce: 'Point of interest address (line 1)',
    tooltipContentAdresseCommerce2: 'Address of point of interest (line 2)',
    tooltipContentLatitude: 'Latitude of point of interest (position on street or in mall)',
    tooltipContentLongitude: 'Longitude of the point of interest (street or mall position)',
    saveConfirmation: 'Do you really want to save the form?',
    saveConfirmationPictures: 'Do you really want to save the pictures?',
    errorSave: 'The information could not be saved due to a cancellation or error.',
    errorSavePictures: 'The photos could not be saved due to an error or cancellation',
    successSave: 'The changes were successfully saved',
    cancelConfirmation: 'Do you really want to cancel your save?',
    addVideo: 'Add a video',
    contentVideo: 'You can add several links to videos. They will be analyzed and broadcast on the media concerned, provided they comply with the following constraints:',
    conditionVideo: 'The url must be a direct access to the file',
    exampleVideo: 'Example: https://exampleVideo/2ssezdsez2dd15e.mp4',
    addUrlVideo: 'Add video url',
    minWeightVideo: 'Weight: 75 Mio maximum',
    timeMaxVideo: 'Duration: 30 seconds maximum',
    resolutionVideo: 'Resolution: 720p minimum',
    warningDiffusion: 'Warning! All broadcasts are final and your link cannot be removed'
  },
  statisticsGoogle: {
    overview: 'Overview',
    titleGoogle: 'General Google statistics',
    sheetEtablishmentEngagement: 'Engagement on the establishment sheet',
    actions: 'Actions carried out from the establishment sheet',
    titleGoogleGraph: 'Evolution of the number of Google searches',
    messages: 'Messages',
    searchByDesktop: 'Google search by computer',
    searchGoogleMapsByDesktop: 'Google Maps search by computer',
    searchByMobile: 'Google search by mobile',
    searchGoogleMapsByMobile: 'Google Maps search by mobile',
    numberSearchByDay: 'Number of searches per day',
    numberConversationByDay: 'Number of conversations per message received on the site',
    numberCallItinerary: 'Number of itinerary request',
    numberClickedButtonCall: 'Number of clicks on the call button',
    numberClickedWebSite: 'Number of clicks on the websit',
    infoNumberStats: 'The numbers in the "On the business listing" section are related to the period shown on the community growth chart.'
  },
  SOH: {
    chooseDate: 'Choose a date',
    textLinked: 'Battery health status provided by a certified organization such as',
    warnings: {
      lowScore: 'Warning: An SOH score below 70% indicates a battery in poor condition.'
    },
    validation: {
      soh: {
        scoreInvalid: 'The SOH score must be a valid number.',
        scoreRange: 'The SOH score must be between 0 and 100%.',
        dateRequired: 'The SOH test date is required.',
        dateFormat: 'The date format must be DD/MM/YYYY.',
        dateFuture: 'The test date cannot be in the future.',
        kilometrageInvalid: 'Mileage must be a valid number.',
        kilometrageNegative: 'Mileage cannot be negative.',
        capaciteInvalid: 'Capacity must be a valid number.',
        capacitePositive: 'Capacity must be greater than 0.',
        autonomieInvalid: 'Range must be a valid number.',
        autonomiePositive: 'Range must be greater than 0.',
        expirationPast: 'The expiration date must be in the future.',
        urlInvalid: 'The URL is not valid'
      }
    }
  }

}
